import LocalizedStrings from 'react-localization';

export const setLanguage = function (locale) {
    lStrings.setLanguage(locale);
    lMembers.setLanguage(locale);
    lNews.setLanguage(locale);
    lJobs.setLanguage(locale);

    const classList = document.documentElement.classList;
    const removeClasses = [];
    for (let i = classList.length - 1; i >= 0; --i) {
        if (classList.item(i).startsWith('font-')) {
            removeClasses.push(classList.item(i));
        }
    }
    if (removeClasses.length > 0) {
        classList.remove(...removeClasses);
    }
    classList.add('font-' + locale);
};

export const getLanguage = function () {
    return lStrings.getLanguage();
};

export const availableLanguages = ['ja', 'ko', 'en'];

export let lStrings = new LocalizedStrings({
    ja: {
        'title_company_name': 'LITEVIEW',
        'title_company_name_formal': 'LITEVIEW株式会社（ライトビュー株式会社）',
        'title_company_slogan': 'No Content, No Life',
        'title_about': 'About',
        'title_contact': 'Contact',
        'title_jobs': 'Jobs',
        'title_members': 'Members',
        'title_member': 'Member',
        'title_technical_adviser': 'Technical Adviser',
        'title_strategy_adviser': 'Strategy Adviser',
        'title_legal_adviser': 'Legal Adviser',
        'title_news': 'News',
        'title_send': '送信',
        'title_name': 'お名前',
        'title_email': 'メールアドレス',
        'title_message': 'メッセージ',
        'title_facebook': 'Facebook',
        'title_twitter': 'Twitter',
        'title_instagram': 'Instagram',
        'title_linkedin': 'LinkedIn',

        'title_contact_service_1': '各種サービスに関するお問い合わせ',
        'title_contact_service_2': '広報・取材に関するお問い合わせ',
        'title_contact_service_3': 'エンジニア募集に関するお問い合わせ',
        'title_contact_service_4': 'デザイナー募集に関するお問い合わせ',
        'title_contact_service_5': 'マーケター募集に関するお問い合わせ',
        'title_contact_service_6': 'その他',
        'title_contact_service_7': 'βテスト参加申し込み',

        'common_more': 'もっと見る',

        'message_error': 'エラー文言',
        'message_mainbg_title': 'Bring out your ideas and talent',
        'message_contact_info': 'ご興味を持った方、技術的な詳細を知りたい方は',
        'message_jobs_info': 'LITEVIEWは、このビジョンを実現するために、新しい仲間を募集しています。<br/>LITEVIEWのビジネスや技術に興味を持っていただいた方のご連絡をお待ちしてます。',
        'message_about_title_1': '弊社の電子透かし技術（RIC）を利用して',
        'message_about_title_2': 'ContentとUserを直接繋ぐ理想的な流通システム',
        'message_about_list_1': 'Userは、コンテンツを見るために、アプリインストール、入会する必要がなくなる',
        'message_about_list_2': 'Content Holderは、ネット上のどこでもコンテンツを画像の形でユーザーに保存させて、課金・広告・Push通知できる',
        'message_about_list_3': 'Userは、ネット上のどこでも 「リンクをクリック→コンテンツのお試し→決済・保存」３Clickでコンテンツの保存可能',

        'message_about_detail_1': 'コンテンツホルダーは、コンテンツとビジネスモデルをLITEVIEW管理者ページに登録して、LITEPLAYとDAL（= Direct Access Link）に変換',
        'message_about_detail_2': 'コンテンツホルダーが、SNSやメディアに発信',
        'message_about_detail_3': '専用アプリのPRではなく、個別コンテンツのDALを拡散',
        'message_about_detail_4': 'ユーザーは、DALをクリックするだけですぐ閲覧できる（アプリインストールや入会が不要）',
        'message_about_detail_5': 'ユーザーは、気になるコンテンツを自分のスマホの写真ギャラリーにLITEPLAYとして保存し、いつでも楽しんだり、購入することができる。また、「そのLITEPLAYを友人にSNSやLINEなどで送ることで」自由にコンテンツを共有することが可能。\n（アプリインストールや入会が不要）',

        'service_top_header1': 'LITEVIEWが提供する',
        'service_top_header2': '3つのコアサービス',
        'service_top_header_space': '\n',
        'service_top_box1': 'LITEVIEWプラットフォーム事業',
        'service_top_box2': '教育・人材育成事業',

        'service_brand_title': 'プラットフォーム事業',
        'service_brand_cta': '詳しく見る',

        'service_brand_refer_subtitle': 'リファラル採用管理',
        'service_brand_refer_title': 'LITEVIEW Refer',
        'service_brand_refer_desc': '従業員やアルバイトの紹介によるリファラル採用を仕組み化し、広告費や仲介手数料を抑えながら、質の高い人材を効率的に採用。\n低コスト・高精度な採用活動を実現する、柔軟な採用管理ツールです。',

        'service_brand_team_subtitle': '社内ポータル構築',
        'service_brand_team_title': 'LITEVIEW Team（2026年3月公開予定）',
        'service_brand_team_desc': '社内チャットはもちろん、ナレッジマネジメント、クラウドストレージ、ワークフロー、勤怠管理などをノーコードで柔軟に一元管理できる社内ポータル構築ソリューションです。\n部署や業務ごとに必要な機能を自由に組み合わせ、スピーディーかつ低コストで導入可能。\n完全無料で今すぐ始められ、情報共有と業務効率の向上を同時に実現します。',

        'service_brand_lv_subtitle': '登録と同時に自社PFの90%完成',
        'service_brand_lv_title': 'LITEVIEW',
        'service_brand_lv_desc': '人数無制限 & 永久無料！\n' +
            '90%の標準機能＋10%の独自拡張。\n' +
            '圧倒的低コストとAPI・AI連携で柔軟な構築が可能なDX基盤です。\n' +
            '※2026年内リリース予定\n',

        'service_brand_frontier_subtitle': '新規事業フルステック支援',
        'service_brand_frontier_title': 'LITEVIEW Frontier',
        'service_brand_frontier_desc': '新規事業の立ち上げに必要なアプリケーションやWebサービスを、ノーコードでスピーディーに構築。企画からMVP開発、運用支援までを一貫サポートする、低予算・短期間のMVP開発支援ソリューションです。\n\n' +
            '※「LITEVIEW Frontier」のすべての案件は、弊社ソリューション「LITEVIEW」をベースにして構築されます。完成済みの堅牢なインフラを土台とすることで、新規事業の立ち上げにおける初期費用や固定費用を極限のレベルまで削減し、事業初期のリスクを最小化します。',

        'service_brand_wee_subtitle': 'β版提供中',
        'service_brand_wee_title': 'Wee by LITEVIEW',
        'service_brand_wee_desc': 'これまで多くのクリエイターの皆様にご愛顧いただいてきた旧「LITEVIEW（個人クリエイター向けプラン）」が、独自の表現活動とファンコミュニティの構築に特化した専用ブランドとしてリニューアル・独立いたしました。\n' +
            'クリエイターが自身の「世界観」を自由に表現し、ファンと深く繋がるための次世代クリエイター支援プラットフォームとして進化を遂げています。\n' +
            'LITEVIEWの強力なノーコード開発技術を活用し、動画配信、ライブ配信、ブログ、オンラインサロンから、月額課金（サブスク）、チケット・グッズ販売（EC）、クラウドファンディングまで、あらゆるコンテンツの発信とマネタイズを1つのアプリで完結。専門知識は一切不要で、初心者からプロフェッショナルまで、自分だけのオリジナルコミュニティを手軽に構築・運営できます。\n\n' +
            '※「Wee by LITEVIEW」のすべての案件は、弊社ソリューション「LITEVIEW」をベースにして構築されます。完成済みの堅牢なインフラを土台とすることで、新規事業の立ち上げにおける初期費用や固定費用を極限のレベルまで削減し、事業初期のリスクを最小化します。',
        'service_brand_wee_cta': 'βテスト参加申し込み',
        'service_brand_wee_cta_desc': '※なお、正式リリース以降は、Webサイト上からご自身で簡単にアカウント登録およびプラットフォームの開設が可能となる予定です。',

        'service_edu_title': '教育・人材育成事業',
        'service_edu_title_desc': '弊社は、プラットフォーム事業とは別に、企業・学校・地域に向けた教育・人材育成支援事業を展開しています。',
        'service_edu_refer_title': 'リファラル採用管理',
        'service_edu_refer_copy': '人と組織を強くする「教育設計と仕組みづくり」',

        'service_edu_desc1': '現場が抱える「学ばせ方」「育て方」「定着させ方」に対して、設計・コンテンツ制作・実行支援まで一貫して行います。',
        'service_edu_desc2': '主な取り組み：',
        'service_edu_desc3': '企業向け：',
        'service_edu_desc4': '現場人材・若手社員の育成研修',
        'service_edu_desc5': '学校・自治体向け：',
        'service_edu_desc6': '探究型・起業教育支援',
        'service_edu_desc7': '教育DX：',
        'service_edu_desc8': '教育コンテンツの設計・配信システム提供',
        'service_edu_desc9': '教材の動画化、学習管理、進捗レポート、テスト自動化などの教育基盤構築を支援',

        'service_jumbotron_title': 'コンテンツ流通の新しいカタチ',
        'service_jumbotron_text': 'コンテンツを様々なメディアに一斉配信・収益化・レポート + ビジネスモデルを自由にコントロールが可能に。',
        'service_jumbotron_01_text': 'コンテンツ + ビジネスを簡単に設定し、複数のメディアに一斉配信・収益化・レポート',
        'service_jumbotron_02_text': 'コンテンツ制作側主導でのマネタイズや、ご希望のUI/UXやビジネスモデルを自由にコントロールが可能',
        'service_jumbotron_03_text': '一斉配信・収益化・レポートにより<br class="d-md-block d-none d-service-custom-br"/>オペレーティングコストを大幅に削減',

        'service_point_01_title': '一斉配信・収益化・レポート',
        'service_point_01_text': 'コンテンツ + ビジネスを簡単に設定し、複数のメディアに一斉配信でき、オペレーティングコストが大幅に削減できるほか、収益レポートを一覧できるツールも提供',
        'service_point_02_title': 'ビジネスモデルを自由にコントロール',
        'service_point_02_text': 'Pre-roll動画広告など多種多様なビジネスモデルによる収益化が可能',
        'service_point_03_title': 'デジタルフォーマット',
        'service_point_03_text': '各フォーマットに対応したNative Playerにより、様々なコンテンツが再生可能なデジタルフォーマット技術を提供します<br/><br/>' +
            '<li>LITEDISC：映像フォーマット</li>' +
            '<li>LITEBOOK：電子書籍フォーマット</li>',

        'service_RIC_point_01': '劣化に強い',
        'service_RIC_point_02': 'コンパクト<br/>サイズ',
        'service_RIC_point_03': '暗号化<br/>＆<br/>復号化',
        'service_RIC_point_04': '特許登録済',

        'service_RIC_text': 'LITEVIEWのサービスは、独自開発のRICを基盤にしています。<br/>RICは画像の劣化や不正な修正に対応可能な唯一のコードマークです。',
        'service_RIC_poster_caption': '※ RICデジタル画像の例',

        'service_top_title_01': 'クリエイターの新しい生存戦略、',
        'service_top_title_02': 'あなたの「世界」を届けよう、',
        'service_top_title_03': 'LITEVIEW',
        'service_top_subtitle_01': 'オリジナルWebサイト＋配信アプリを１分で開設',
        'service_top_subtitle_02': '"全て"をこの１つに、 動画・ライブ・ブログからオンラインサロン・物販まで',
        'service_top_subtitle_03': '初期費用、手数料はずっと0円',
        'service_top_subtitle_04': 'クリエイターの皆さまを応援するお手軽な料金',
        'service_top_link': 'LITEVIEWのホームページに移動',

        'service_about_title_01': '価値あるコンテンツは',
        'service_about_title_02': '有料で見る時代',
        'service_about_message_01': '価値のあるデジタルコンテンツに、',
        'service_about_message_021': '視聴者が対価を支払うのは',
        'service_about_message_022': '今やあたりまえの時代。',
        'service_about_message_031': 'クリエイターが自分だけの',
        'service_about_message_032': 'オリジナル配信サービスを持てたら',
        'service_about_message_04': 'もっと自由に、もっと価値を生み出せる。',
        'service_about_message_05': 'LITEVIEWならその世界を実現できる。',

        'service_feature_header_title': 'あなたの「世界」を自由自在に作れる！',
        'service_feature_01': 'オリジナルWebサイト+配信アプリがたった1分で簡単開設！',
        'service_feature_02': '動画/ライブ配信/ラジオ/ブログ/写真集/予約制配信など、自由自在にコンテンツ配信が可能！',
        'service_feature_03': '無料配信/月額会員/年間会員/都度課金/物販/クラウドファンディングなど、販売方法は自由に選べます！',
        'service_feature_04': '初期費用0円、販売手数料ずっと0円！さらにお手軽な利用料金まで！',
        'service_feature_051': 'ノーコードなのでサービスの管理が誰でも簡単にできる',
        'service_feature_052': '（配信コンテンツの登録・料金設定・アプリ/サイトのデザインが全て自由に）',

        'service_content_header_title': 'あなたの希望に合わせて配信コンテンツを自由自在に',
        'service_content_header_text': 'LITEVIEWはあらゆるタイプのデジタルコンテンツに対応しています',
        'service_content_type_01': '動画・ライブ配信',
        'service_content_type_02': '写真集・ブログ',
        'service_content_type_03': 'ライブコマース・物販',
        'service_content_type_04': 'ラジオ・音源',
        'service_content_type_05': 'クラウドファンディング',
        'service_content_type_06': '予約制ライブ配信',
        'service_content_type_07': 'オンラインイベント',
        'service_content_type_08': 'オンラインサロン/レッスン/講義',
        'service_content_type_09': 'オンラインスクール',

        'news_back_to_list': 'ニュース一覧に戻る',

        'team_jumbotron_title': '多彩なキャリアや経験を持ったメンバー',
        'team_jumbotron_text': 'Samsung(サムスン電子)等の大企業出身者から、スタートアップでExitを経験したメンバーまで。<br/>' +
            '国籍を問わず様々なキャリアのメンバーが集まっており、ビジネスモデルと将来性を認められ電通・Samsung・LINEなどのグローバル企業と、ベンチャー業界の投資家から出資いただいております。',

        'contact_company_address_section': 'Office',
        'contact_company_address_jp': '日本本社',
        'contact_company_address_jp_address': '〒108-0014\n東京都港区芝５丁目３４－２',
        'contact_company_address_kr': '韓国支社',
        'contact_company_address_kr_address': '416, Hangang-daero, Jung-gu, Seoul, 04637',
        'contact_company_email_comment': 'LITEVIEWのサービスについて、募集ポジションについて、取材についてなど、お気軽にご連絡ください。',
        'contact_download_btn': 'ダウンロード',

        'job_jumbotron_title': 'LITEVIEWと一緒に世界を変える仲間を募集しています',
        'job_jumbotron_text': 'ノーコードで自社アプリ・Web・管理機能を一気通貫で構築できる「LITEVIEW」を展開、<br/>' +
            '従来の100分の1のコストで顧客の新規事業やDXを加速させる、イノベーション・スタートアップ、LITEVIEW株式会社です。<br/>' +
            'おかげさまでローンチからわずか3年で億単位の黒字化を実現。<br/>' +
            '今年は全職種で組織拡大を行う「第二創業期」に突入しました。<br/>' +
            '急成長中の環境で、共にスケールアップを目指しませんか？<br/>' +
            '<br/>' +
            '【弊社サービス】<br/>' +
            '▼新規事業のMVPをノーコードで即構築＆低予算運用｜<a href="https://frontier.liteview.jp" target="_blank">LITEVIEW Frontier</a><br/>' +
            '▼低予算で社内ポータルを即構築｜<a href="https://team.liteview.jp" target="_blank">LITEVIEW Team</a><br/>' +
            '<br/>' +
            '◎会社やお仕事の詳細はこちらもご覧ください<br/>◎<a href="https://youtrust.jp/recruitment_posts/434f308fd0e5582005b8a0fe5116f6f4" target="_blank">https://youtrust.jp/recruitment_posts/434f308fd0e5582005b8a0fe5116f6f4</a><br/>' +
            '<br/>' +
            '少しでもご興味あれば、「まずは話だけ」でも大歓迎です！<br/>' +
            'ぜひお気軽にご連絡ください◎',
        'job_position_title': '募集ポジション',


        'alt_facebook_share': 'Facebookへ共有',
        'alt_twitter_share': 'Twitterへ共有',
        'alt_ios_enginner': 'iOS Engineer',
        'alt_and_enginner': 'Android Engineer',
        'alt_web_enginner': 'Web Engineer',
        'alt_server_enginner': 'Server Engineer',
        'alt_main_background': '背景',

        'link_ios_engineer': 'https://www.wantedly.com/projects/223929',
        'link_and_engineer': 'https://www.wantedly.com/projects/223932',
        'link_server_engineer': 'https://www.wantedly.com/projects/223920',
        'link_web_engineer': 'https://www.wantedly.com/projects/223933',

        'link_investor_zcaptial': 'https://zvc.vc/',
        'link_investor_line': 'https://lineventurescorp.com/ja/',
        'link_investor_dentsu': 'http://www.dentsu.co.jp/',
        'link_investor_dkgate': 'https://www.garage.co.jp/ja/pr/2015/02/20150219.html',
        'link_investor_bonangels': 'http://bonangels.net/',

        'footer_main_message': 'LITEVIEWはビジョンを一緒に実現する仲間を募集しています。お気軽にお問い合わせください。',
        'footer_main_btn': '募集要項',
        'footer_href_liteview': 'LITEVIEWは貴社の新事業・DX戦略を支援します。お気軽にお問い合わせください。',
        'footer_contact_message': 'LITEVIEWは貴社の新事業・DX戦略を支援します。お気軽にお問い合わせください。',
        'footer_liteview_btn': 'LITEVIEWのホームページに移動',
        'footer_contact_btn': 'お問い合わせ',
        'footer_jobs_message': 'ご興味のあるポジションがあれば、お気軽にお問い合わせください。',
        'footer_jobs_btn': 'お問い合わせ',

        'error_name_required': 'このフィールドを入力してください。',
        'error_email_required': 'このフィールドを入力してください。',
        'error_email_type_mismatch': 'メールアドレスに「@」を挿入してください。',
        'error_message_required': 'このフィールドを入力してください。',
        'confirm_external_link': '外部サイトに移動します。よろしいでしょうか？',

        'job_header_poster_01': 'Pull your idea & talent',
        'resources_logo': 'LITEVIEW',
        'resources_poster_01': 'Pull your idea and talent',
        'resources_poster_02': 'No Content, No Life',
        'resources_poster_03': 'Be the one',
        'resources_poster_04': 'Distribution new value',
        'service_device_01': 'Distribution',
        'service_device_02': 'Play',
        'service_device_03': 'Monetize',
        'service_point_01': 'Native Player',
        'service_point_02': '写真アプリに画像として保存',
        'service_point_03': 'デジタルフォーマット',
        'service_codemark': 'RIC (Robust Index Code)',
        'service_poster': 'RICデジタル画像の例',
        'investors_logo_01': 'Z Venture Capital',
        'investors_logo_02': 'DK Gate',
        'investors_logo_03': 'Bon Angels',
        'investors_logo_etc': 'その他多数',

        'sns_tweet_url': 'https://twitter.com/intent/tweet?url=https%3A%2F%2Fpulit.jp&text=LITEVIEW%e3%81%af%e6%96%b0%e3%81%97%e3%81%84%e3%82%b3%e3%83%b3%e3%83%86%e3%83%b3%e3%83%84%e6%b5%81%e9%80%9a%e3%82%a4%e3%83%b3%e3%83%95%e3%83%a9%e3%82%92%e6%a7%8b%e7%af%89%e3%81%97%e3%81%a6%e3%81%84%e3%81%be%e3%81%99%20%7c%20LITEVIEW%e6%a0%aa%e5%bc%8f%e4%bc%9a%e7%a4%be',
        'sns_share_url': 'https://facebook.com/sharer/sharer.php?app_id=113869198637480&sdk=joey&u=http%3A%2F%2Fpulit.jp%2F&display=popup&ref=plugin&src=share_button'
    },
    ko: {
        'title_company_name': 'LITEVIEW',
        'title_company_name_formal': 'LITEVIEW Inc.',
        'title_company_slogan': 'No Content, No Life',
        'title_about': 'About',
        'title_contact': 'Contact',
        'title_jobs': 'Jobs',
        'title_members': 'Members',
        'title_member': 'Member',
        'title_technical_adviser': 'Technical Adviser',
        'title_strategy_adviser': 'Strategy Adviser',
        'title_legal_adviser': 'Legal Adviser',
        'title_news': 'News',
        'title_send': '보내기',
        'title_name': '성명',
        'title_email': '메일 주소',
        'title_message': '내용',
        'title_facebook': 'Facebook',
        'title_twitter': 'Twitter',
        'title_instagram': 'Instagram',
        'title_linkedin': 'LinkedIn',

        'title_contact_service_1': '서비스에 관한 문의',
        'title_contact_service_2': '광고・취재에 관한 문의',
        'title_contact_service_3': '개발자 모집에 관한 문의',
        'title_contact_service_4': '디자이너 모집에 관한 문의',
        'title_contact_service_5': '마케터 모집에 관한 문의',
        'title_contact_service_6': '기타',
        'title_contact_service_7': 'β테스트 참가 신청',

        'common_more': '더보기',

        'message_error': '에러 내용',
        'message_mainbg_title': 'Bring out your ideas and talent',
        'message_contact_info': 'ご興味を持った方、技術的な詳細を知りたい方は',
        'message_jobs_info': 'LITEVIEWは、このビジョンを実現するために、新しい仲間を募集しています。\nLITEVIEWのビジネスや技術に興味を持っていただいた方のご連絡をお待ちしてます。',
        'message_about_title_1': '弊社の電子透かし技術（RIC）を利用して',
        'message_about_title_2': 'ContentとUserを直接繋ぐ理想的な流通システム',
        'message_about_list_1': 'Userは、コンテンツを見るために、アプリインストール、入会する必要がなくなる',
        'message_about_list_2': 'Content Holderは、ネット上のどこでもコンテンツを画像の形でユーザーに保存させて、課金・広告・Push通知できる',
        'message_about_list_3': 'Userは、ネット上のどこでも 「リンクをクリック→コンテンツのお試し→決済・保存」３Clickでコンテンツの保存可能',

        'message_about_detail_1': 'コンテンツホルダーは、コンテンツとビジネスモデルをLITEVIEW管理者ページに登録して、LITEPLAYとDAL（= Direct Access Link）に変換',
        'message_about_detail_2': 'コンテンツホルダーが、SNSやメディアに発信',
        'message_about_detail_3': '専用アプリのPRではなく、個別コンテンツのDALを拡散',
        'message_about_detail_4': 'ユーザーは、DALをクリックするだけですぐ閲覧できる（アプリインストールや入会が不要）',
        'message_about_detail_5': 'ユーザーは、気になるコンテンツを自分のスマホの写真ギャラリーにLITEPLAYとして保存し、いつでも楽しんだり、購入することができる。また、「そのLITEPLAYを友人にSNSやLINEなどで送ることで」自由にコンテンツを共有することが可能。\n（アプリインストールや入会が不要）',

        'service_top_header1': 'LITEVIEW가 제공하는',
        'service_top_header2': '3가지 코어 서비스',
        'service_top_header_space': '\n',
        'service_top_box1': 'LITEVIEW 플랫폼 사업',
        'service_top_box2': '교육 및 인재 육성 사업',

        'service_brand_title': '플랫폼 사업',
        'service_brand_cta': '자세히 보기',

        'service_brand_refer_subtitle': '리퍼럴 채용 관리',
        'service_brand_refer_title': 'LITEVIEW Refer',
        'service_brand_refer_desc': '임직원 및 아르바이트의 추천을 통한 리퍼럴 채용을 시스템화하여 광고비와 중개 수수료를 줄이면서, 우수 인재를 효율적으로 채용합니다.\n저비용·고정확도의 채용 활동을 실현하는 유연한 채용 관리 도구입니다.',

        'service_brand_team_subtitle': '사내 포털 구축',
        'service_brand_team_title': 'LITEVIEW Team (2026년 3월 공개 예정)',
        'service_brand_team_desc': '무료 사내 채팅은 물론, 나리지 매니지먼트, 클라우드 스토리지, 워크플로우, 근태 관리 등을 노코드로 유연하게 통합 관리할 수 있는 사내 포털 구축 솔루션입니다.\n부서 및 업무에 따라 필요한 기능을 자유롭게 조합하여 빠르고 저렴하게 도입 가능.\n완전 무료로 지금 바로 시작할 수 있으며, 정보 공유와 업무 효율의 향상을 동시에 실현합니다.',

        'service_brand_lv_subtitle': '등록과 동시에 자사 PF 90% 완성',
        'service_brand_lv_title': 'LITEVIEW',
        'service_brand_lv_desc': '인원 제한 없음 & 평생 무료!\n' +
            '90%의 표준 기능 ＋ 10%의 독자적 확장.\n' +
            '압도적인 저비용과 API·AI 연동으로 유연한 구축이 가능한 DX 기반입니다.\n' +
            '※2026년 내 출시 예정\n',

        'service_brand_frontier_subtitle': '신규 사업 풀스택 지원',
        'service_brand_frontier_title': 'LITEVIEW Frontier',
        'service_brand_frontier_desc': '신규 사업 론칭에 필요한 애플리케이션이나 웹 서비스를 노코드로 신속하게 구축. 기획부터 MVP 개발, 운영 지원까지 일관되게 서포트하는 저예산·단기간 MVP 개발 지원 솔루션입니다.\n\n' +
            '※「LITEVIEW Frontier」의 모든 프로젝트는 자사 솔루션인 「LITEVIEW」를 기반으로 구축됩니다. 이미 완성된 견고한 인프라를 토대로 삼음으로써, 신규 사업 론칭 시 발생하는 초기 비용과 고정 비용을 극적인 수준까지 절감하고 사업 초기 리스크를 최소화합니다.',

        'service_brand_wee_subtitle': 'β(베타) 버전 제공 중',
        'service_brand_wee_title': 'Wee by LITEVIEW',
        'service_brand_wee_desc': '그동안 수많은 크리에이터분들께 사랑받아 온 기존 「LITEVIEW(개인 크리에이터용 플랜)」가 독창적인 표현 활동과 팬 커뮤니티 구축에 특화된 전용 브랜드로 리뉴얼 및 독립하였습니다.\n' +
            '크리에이터가 자신의 「세계관」을 자유롭게 표현하고 팬들과 깊게 연결될 수 있도록 돕는 차세대 크리에이터 지원 플랫폼으로 진화하고 있습니다.\n' +
            'LITEVIEW의 강력한 노코드 개발 기술을 활용하여 동영상 스트리밍, 라이브 방송, 블로그, 온라인 살롱부터 월간 정기 구독, 티켓·굿즈 판매(EC), 크라우드 펀딩까지 모든 콘텐츠 발행과 수익화를 하나의 앱으로 완결. 전문 지식은 전혀 필요 없으며, 초보자부터 전문가까지 자신만의 오리지널 커뮤니티를 손쉽게 구축하고 운영할 수 있습니다.\n\n' +
            '※ 「Wee by LITEVIEW」의 모든 프로젝트는 자사 솔루션인 「LITEVIEW」를 기반으로 구축됩니다. 이미 완성된 견고한 인프라를 토대로 삼음으로써, 신규 사업 론칭 시 발생하는 초기 비용과 고정 비용을 극적인 수준까지 절감하고 사업 초기 리스크를 최소화합니다.',
        'service_brand_wee_cta': 'β테스트 참여 신청',
        'service_brand_wee_cta_desc': '※ 아울러 정식 출시 이후에는 웹사이트를 통해 직접 간편하게 계정 등록 및 플랫폼 개설을 하실 수 있을 예정입니다.',

        'service_edu_title': '교육 및 인재 육성 사업',
        'service_edu_title_desc': '당사는 플랫폼 사업과는 별도로, 기업·학교·지역을 대상으로 한 교육 및 인재 육성 지원 사업을 전개하고 있습니다.',
        'service_edu_refer_title': '리퍼럴 채용 관리',
        'service_edu_refer_copy': '사람과 조직을 강하게 만드는 “교육 설계와 시스템 구축”',

        'service_edu_desc1': '현장에서 마주하는 “학습 방식”, “육성 방식”, “정착 방식”에 대해 설계부터 콘텐츠 제작, 실행 지원까지 일괄 제공하고 있습니다.',
        'service_edu_desc2': '주요 활동: ',
        'service_edu_desc3': '기업 대상: ',
        'service_edu_desc4': '현장 인력 및 신입 사원 육성 교육',
        'service_edu_desc5': '학교 및 지자체 대상: ',
        'service_edu_desc6': '탐구형 및 창업 교육 지원',
        'service_edu_desc7': '교육 DX: ',
        'service_edu_desc8': '교육 콘텐츠 설계 및 제공 시스템 구축',
        'service_edu_desc9': '교육 영상 제작, 학습 관리, 진도 리포트, 시험 자동화 등 교육 기반 시스템 구축을 지원',

        'service_jumbotron_title': '새로운 콘텐츠 유통방식',
        'service_jumbotron_text': '콘텐츠를 여러 미디어에 동시 발신・수익화・리포트 + 비즈니스 모델을 자유롭게 컨트롤이 가능.',
        'service_jumbotron_01_text': '콘텐츠 + 비즈니스를 간단하게 설정,<br class="d-md-block d-none d-service-custom-br"/> 여러 미디어에 동시 발신・수익화・리포트',
        'service_jumbotron_02_text': '콘텐츠 제작사 주도의 수익화・UI/UX・비즈니스 모델을 자유로이 설정 가능.',
        'service_jumbotron_03_text': '동시 발신・수익화・리포트로<br class="d-md-block d-none d-service-custom-br"/> 운영 비용을 대폭 절감',

        'service_point_01_title': '동시 발신・수익화・리포트',
        'service_point_01_text': '콘텐츠 + 비즈니스를 간단하게 설정하여 여러 미디어에 발신할 수 있고, 운영 비용을 대폭 절감이 가능하며 수익 리포트를 일람할 수 있는 툴도 제공.',
        'service_point_02_title': '비즈니스 모델을 자유로이 컨트롤',
        'service_point_02_text': 'Pre-roll 영상광고 등 다양한 비즈니스 모델로 수익화가 가능.',
        'service_point_03_title': '디지털 포맷',
        'service_point_03_text': '이미지에 콘텐츠 정보를 저장하여 언제든지 편리하게 콘텐츠를 재생할 수 있는 디지털 포맷 기술을 보유하고 있습니다.<br/><br/>' +
            '<li>LITEDISC : 동영상 포맷</li>' +
            '<li>LITEBOOK : 전자책 포맷</li>',

        'service_RIC_point_01': '열화에 강함',
        'service_RIC_point_02': '작은 사이즈',
        'service_RIC_point_03': '암호화<br/>&<br/>복호화',
        'service_RIC_point_04': '특허 완료',

        'service_RIC_text': 'LITEVIEW의 서비스가 가능한 이유는 RIC 덕분입니다.<br/>' +
            'RIC는 LITEVIEW이 독자개발한 기술로서 인터넷 상의 열화 및 불법수정에 대응가능한 유일한 코드마크 기술입니다.',
        'service_RIC_poster_caption': '※ 이미지에 적용된 RIC 예시',

        'service_top_title_01': '콘텐츠 수익화를 지원하는',
        'service_top_title_02': '개개인의 크리에이터를',
        'service_top_title_03': '위한 LITEVIEW',
        'service_top_subtitle_01': '누구나 간단하게 자신만의 전송 서비스를 설계!',
        'service_top_subtitle_02': '모든 컨텐츠 유형 지원!',
        'service_top_subtitle_03': '초기 비용 없음, 판매 수수료 없음!',
        'service_top_link': 'LITE VIEW 홈페이지로 이동',

        'service_about_title_01': '가치 있는 콘텐츠는',
        'service_about_title_02': '유료로 보는 시대',
        'service_about_message_01': '가치 있는 디지털 콘텐츠에',
        'service_about_message_021': '시청자가 대가를 지불하는 것은',
        'service_about_message_022': '바야흐로 당연한 시대.',
        'service_about_message_031': '크리에이터가 나만의',
        'service_about_message_032': '오리지널 전달 서비스를 가지면',
        'service_about_message_04': '더 자유롭게, 더 가치를 창출할 수 있다.',
        'service_about_message_05': 'LITEVIEW라면 그 세계를 실현할 수 있다.',

        'service_feature_header_title': 'LITEVIEW가 선택되는 이유',
        'service_feature_011': '당신만의 독자적인 전송 서비스를 만들 수 있다',
        'service_feature_012': '(오리지널 사이트 및 원본 앱 개설 가능)',
        'service_feature_02': '간단한 정보 입력만으로 바로 개설 가능',
        'service_feature_03': '초기비용 없음',
        'service_feature_04': '매출분배(리베뉴 점유율)는 일체 없음',
        'service_feature_051': '노코드라 서비스 관리를 누구나 쉽게 할 수 있다',
        'service_feature_052': '전달 콘텐츠의 등록, 요금설정, 앱/사이트 디자인이 모두 자유롭게)',

        'service_content_header_title': '다양한 콘텐츠의 전송 가능',
        'service_content_header_text': 'LITE VIEW는 모든 유형의 디지털 콘텐츠를 지원합니다',
        'service_content_type_01': '동영상·라이브 전달',
        'service_content_type_02': '화보집, 블로그',
        'service_content_type_03': '라이브커머스',
        'service_content_type_04': '라디오 음원',
        'service_content_type_05': '온라인 악수(사인)회',
        'service_content_type_06': '온라인 상담',
        'service_content_type_07': '팬 커뮤니티',
        'service_content_type_08': '온라인 교육',
        'service_content_type_09': '온라인 스쿨',

        'news_back_to_list': '목록으로 돌아가기',

        'team_jumbotron_title': '다양한 경력과 탁월한 실력',
        'team_jumbotron_text': '도쿄에 위치한 LITEVIEW는 삼성, 라인 등 대기업 출신부터 스타트업의 Exit를 경험한 멤버까지,<br/>' +
            '국적을 불문하고 다양한 경력의 멤버들이 모여 성장하고 있습니다.<br/><br/>' +
            '그리고 이를 바탕으로 비즈니스 모델과 실력을 인정받아 Dentsu, 삼성, 라인 등 글로벌 기업과<br/>' +
            '벤처업계 투자자들로부터 투자를 유치하였습니다.',

        'contact_company_address_section': 'Office',
        'contact_company_address_jp': '일본 본사',
        'contact_company_address_jp_address': '5-34-2 Shiba, Minato-ku, Tokyo, 108-0014',
        'contact_company_address_kr': '한국 지사',
        'contact_company_address_kr_address': '〒04637\n서울특별시 중구 한강대로 416',
        'contact_company_email_comment': 'LITEVIEW 서비스, 채용지원, 취재 등 언제든지 문의주세요.',
        'contact_download_btn': '다운로드',

        'job_jumbotron_title': 'LITEVIEW와 함께 세계를 바꿀 동료를 모집하고 있습니다.',
        'job_jumbotron_text': '노코드로 자사 앱·Web·관리 기능을 한 번에 구축할 수 있는 「LITEVIEW」로,<br/>' +
            '기존의 서비스들에 대비 1/100의 비용으로 고객의 신규 사업과 DX를 가속화하는 혁신 스타트업, <br/>' +
            'LITEVIEW 주식회사입니다.<br/>' +
            '<br/>' +
            '서비스 릴리스 불과 3년 만에 수억원 이상의 흑자화를 실현하고,<br/>' +
            '올해는 전 직종에서 조직 확대를 하는 「제2창업기」에 돌입했습니다. <br/>' +
            '급성장 중인 환경에서 함께 스케일업(Scale-up)을 목표로 달려보지 않으시겠습니까?<br/>' +
            '<br/>' +
            '【자사 서비스】 <br/>' +
            '- ▼ 신규 사업의 MVP를 노코드로 즉시 구현 및 저예산 운용 | <a href="https://frontier.liteview.jp" target="_blank">LITEVIEW Frontier</a><br/>' +
            '- ▼ 저예산으로 사내 포털 즉시 구현 | <a href="https://team.liteview.jp" target="_blank">LITEVIEW Team</a><br/>' +
            '<br/>' +
            '◎회사 및 업무에 대한 상세 내용은 이쪽도 확인해 주세요<br/>' +
            '◎<a href="https://youtrust.jp/recruitment_posts/434f308fd0e5582005b8a0fe5116f6f4" target="_blank">https://youtrust.jp/recruitment_posts/434f308fd0e5582005b8a0fe5116f6f4</a><br/>' +
            '<br/>' +
            '조금이라도 흥미가 있으시다면, 「가볍게 커피타임이라도」 대환영입니다! <br/>' +
            '부담 없이 연락해 주세요◎',
        'job_position_title': '채용중인 포지션',


        'alt_facebook_share': 'Facebookへ共有',
        'alt_twitter_share': 'Twitterへ共有',
        'alt_ios_enginner': 'iOS Engineer',
        'alt_and_enginner': 'Android Engineer',
        'alt_web_enginner': 'Web Engineer',
        'alt_server_enginner': 'Server Engineer',
        'alt_main_background': '배경',

        'link_ios_engineer': 'https://www.wantedly.com/projects/223929',
        'link_and_engineer': 'https://www.wantedly.com/projects/223932',
        'link_server_engineer': 'https://www.wantedly.com/projects/223920',
        'link_web_engineer': 'https://www.wantedly.com/projects/223933',

        'link_investor_zcaptial': 'https://zvc.vc/',
        'link_investor_line': 'https://lineventurescorp.com/en/',
        'link_investor_dentsu': 'http://www.dentsu.com/',
        'link_investor_dkgate': 'https://www.garage.co.jp/en/',
        'link_investor_bonangels': 'http://bonangels.net/',

        'footer_main_message': 'LITEVIEW의 비전을 함께 실현할 멤버를 찾고 있습니다.\n' +
            '좋은 사람들과 멋진 일을 하고 싶습니다.',
        'footer_main_btn': '모집 요강',
        'footer_href_liteview': 'LITEVIEW는 귀사의 신사업 및 DX전략을 지원합니다. 가볍게 문의해 주세요.',
        'footer_contact_message': 'LITEVIEW는 귀사의 신사업 및 DX전략을 지원합니다. 가볍게 문의해 주세요.',
        'footer_liteview_btn': 'LITEVIEW 홈페이지로 이동',
        'footer_contact_btn': '문의',
        'footer_jobs_message': '지원하고 싶은 포지션에 자유양식으로 이력서와 함께 문의해 주세요.',
        'footer_jobs_btn': '문의하기',

        'error_name_required': '이 입력란을 작성하세요.',
        'error_email_required': '이 입력란을 작성하세요.',
        'error_email_type_mismatch': '이메일 주소에 \'@\'를 포함해 주세요.',
        'error_message_required': '이 입력란을 작성하세요.',
        'confirm_external_link': '외부 페이지로 이동합니다. 이동하시겠습니까?',

        'job_header_poster_01': 'Pull your idea and talent',
        'resources_logo': 'LITEVIEW',
        'resources_poster_01': 'Pull your idea and talent',
        'resources_poster_02': 'No Content, No Life',
        'resources_poster_03': 'Be the one',
        'resources_poster_04': 'Distribution new value',
        'service_device_01': 'Distribution',
        'service_device_02': 'Play',
        'service_device_03': 'Monetize',
        'service_point_01': '전용 플레이어 (네이티브 앱)',
        'service_point_02': '사진앱에 이미지로 저장',
        'service_point_03': '디지털 포맷',
        'service_codemark': 'RIC (Robust Index Code)',
        'service_poster': '이미지에 적용된 RIC 예시',
        'investors_logo_01': 'Z Venture Capital',
        'investors_logo_02': 'DK Gate',
        'investors_logo_03': 'Bon Angels',
        'investors_logo_etc': '그 외 다수',

        'sns_tweet_url': 'https://twitter.com/intent/tweet?url=https%3A%2F%2Fpulit.jp&text=LITEVIEW는+콘텐츠+유통방식을+새롭게+만들고+있습니다+%7C+LITEVIEW+Inc',
        'sns_share_url': 'https://facebook.com/sharer/sharer.php?app_id=113869198637480&sdk=joey&u=http%3A%2F%2Fpulit.jp%2F&display=popup&ref=plugin&src=share_button'
    },
    en: {
        'title_company_name': 'LITEVIEW',
        'title_company_name_formal': 'LITEVIEW Inc.',
        'title_company_slogan': 'No Content, No Life',
        'title_about': 'About',
        'title_contact': 'Contact',
        'title_jobs': 'Jobs',
        'title_members': 'Members',
        'title_member': 'Member',
        'title_technical_adviser': 'Technical Adviser',
        'title_strategy_adviser': 'Strategy Adviser',
        'title_legal_adviser': 'Legal Adviser',
        'title_news': 'News',
        'title_send': 'Send',
        'title_name': 'Name',
        'title_email': 'E-mail',
        'title_message': 'Message',
        'title_facebook': 'Facebook',
        'title_twitter': 'Twitter',
        'title_instagram': 'Instagram',
        'title_linkedin': 'LinkedIn',

        'title_contact_service_1': 'Contact about the service',
        'title_contact_service_2': 'Contact about the interview',
        'title_contact_service_3': 'Contact about hiring engineers',
        'title_contact_service_4': 'Contact about hiring designers',
        'title_contact_service_5': 'Contact about hiring marketers',
        'title_contact_service_6': 'etc.',
        'title_contact_service_7': 'Apply for Beta Test',

        'common_more': 'See more',

        'message_error': 'Error description',
        'message_mainbg_title': 'Bring out your ideas and talent',
        'message_contact_info': 'ご興味を持った方、技術的な詳細を知りたい方は',
        'message_jobs_info': 'LITEVIEWは、このビジョンを実現するために、新しい仲間を募集しています。\nLITEVIEWのビジネスや技術に興味を持っていただいた方のご連絡をお待ちしてます。',
        'message_about_title_1': '弊社の電子透かし技術（RIC）を利用して',
        'message_about_title_2': 'ContentとUserを直接繋ぐ理想的な流通システム',
        'message_about_list_1': 'Userは、コンテンツを見るために、アプリインストール、入会する必要がなくなる',
        'message_about_list_2': 'Content Holderは、ネット上のどこでもコンテンツを画像の形でユーザーに保存させて、課金・広告・Push通知できる',
        'message_about_list_3': 'Userは、ネット上のどこでも 「リンクをクリック→コンテンツのお試し→決済・保存」３Clickでコンテンツの保存可能',

        'message_about_detail_1': 'コンテンツホルダーは、コンテンツとビジネスモデルをLITEVIEW管理者ページに登録して、LITEPLAYとDAL（= Direct Access Link）に変換',
        'message_about_detail_2': 'コンテンツホルダーが、SNSやメディアに発信',
        'message_about_detail_3': '専用アプリのPRではなく、個別コンテンツのDALを拡散',
        'message_about_detail_4': 'ユーザーは、DALをクリックするだけですぐ閲覧できる（アプリインストールや入会が不要）',
        'message_about_detail_5': 'ユーザーは、気になるコンテンツを自分のスマホの写真ギャラリーにLITEPLAYとして保存し、いつでも楽しんだり、購入することができる。また、「そのLITEPLAYを友人にSNSやLINEなどで送ることで」自由にコンテンツを共有することが可能。\n（アプリインストールや入会が不要）',

        'service_top_header1': '3 Core Services',
        'service_top_header2': 'Provided by LITEVIEW',
        'service_top_header_space': '\n',
        'service_top_box1': 'LITEVIEW Platform Business',
        'service_top_box2': 'Education & Human Resource Development',

        'service_brand_title': 'Platform Business',
        'service_brand_cta': 'Learn More',

        'service_brand_refer_subtitle': 'Referral Recruitment Management',
        'service_brand_refer_title': 'LITEVIEW Refer',
        'service_brand_refer_desc': 'Systematizes referral hiring through employee and part-time staff introductions, reducing advertising and intermediary costs while efficiently securing high-quality talent.\nA flexible recruitment management tool that enables low-cost, high-precision hiring activities.',

        'service_brand_team_subtitle': 'In-house Portal Development',
        'service_brand_team_title': 'LITEVIEW Team (Scheduled for release in March 2026)',
        'service_brand_team_desc': 'A no-code solution for building an internal portal that flexibly integrates free internal chat, knowledge management, cloud storage, workflows, attendance management, and more.\nYou can freely combine features by department or task to implement it quickly and cost-effectively.\nStart immediately for free, and achieve improved information sharing and operational efficiency simultaneously.',

        'service_brand_lv_subtitle': 'Complete 90% of Your Own Platform Instantly Upon Registration',
        'service_brand_lv_title': 'LITEVIEW',
        'service_brand_lv_desc': 'Unlimited Members & Free Forever!\n' +
            '90% Standard Features + 10% Custom Extensions.\n' +
            'A DX foundation that enables flexible building through overwhelming low costs, API, and AI integration.\n' +
            '*Scheduled for release within 2026\n',

        'service_brand_frontier_subtitle': 'Full-Stack Support for New Businesses',
        'service_brand_frontier_title': 'LITEVIEW Frontier',
        'service_brand_frontier_desc': 'Rapidly build applications and web services required for launching new businesses using no-code technology. A low-budget, short-term MVP development support solution that provides end-to-end support from planning to MVP development and operational assistance.\n\n' +
            '*All LITEVIEW Frontier projects are built based on our proprietary solution, LITEVIEW. By leveraging a pre-built, robust infrastructure as a foundation, initial and fixed costs for launching a new business are reduced to the absolute minimum, mitigating early-stage business risks.',

        'service_brand_wee_subtitle': 'Beta Version Now Available',
        'service_brand_wee_title': 'Wee by LITEVIEW',
        'service_brand_wee_desc': 'The former "LITEVIEW (Plan for Individual Creators)," which has been loved by many creators, has been rebranded and spun off as a dedicated brand specialized in unique expressive activities and building fan communities.\n' +
            'It has evolved into a next-generation creator support platform where creators can freely express their "worldview" and connect deeply with their fans.\n' +
            'By leveraging LITEVIEW\'s powerful no-code development technology, all aspects of content distribution and monetization—from video streaming, live broadcasting, blogging, and online salons to monthly subscriptions, ticket/merchandise sales (E-commerce), and crowdfunding—can be managed within a single app. No technical expertise is required, allowing everyone from beginners to professionals to easily build and operate their own original community.\n\n' +
            '*All Wee by LITEVIEW projects are built based on our proprietary solution, LITEVIEW. By leveraging a pre-built, robust infrastructure as a foundation, initial and fixed costs for launching a new business are reduced to the absolute minimum, mitigating early-stage business risks.',
        'service_brand_wee_cta': 'Apply for Beta Testing',
        'service_brand_wee_cta_desc': '*Please note that after the official release, you will be able to easily register an account and launch your own platform directly from our website.',

        'service_edu_title': 'Education & Human Resource Development',
        'service_edu_title_desc': 'In addition to our platform business, we offer educational and human resource development services for companies, schools, and local communities.',
        'service_edu_refer_title': 'Referral Recruitment Management',
        'service_edu_refer_copy': '“Educational design and system building” to strengthen people and organizations',

        'service_edu_desc1': 'We provide comprehensive support from design and content production to implementation for field challenges such as how to teach, train, and retain talent.',
        'service_edu_desc2': 'Main initiatives:',
        'service_edu_desc3': 'For companies: ',
        'service_edu_desc4': 'Training programs for frontline personnel and young employees',
        'service_edu_desc5': 'For schools and municipalities: ',
        'service_edu_desc6': 'Support for inquiry-based and entrepreneurship education',
        'service_edu_desc7': 'Educational DX: ',
        'service_edu_desc8': 'Provision of systems for designing and delivering educational content',
        'service_edu_desc9': 'Support for building educational infrastructure such as video-based learning, learning management, progress reports, and test automation',

        'service_jumbotron_title': 'Brand-new Content Distribution Infra',
        'service_jumbotron_text': 'LITEVIEW offers simultaneous distribution to various media, monetization, reporting of content<br class="d-md-block d-none d-service-custom-br"/> and control business models as you want.',
        'service_jumbotron_01_text': 'Easily set up content + business and distribute, monetize and report on multiple media simultaneously.',
        'service_jumbotron_02_text': 'Monetization, desired UI / UX, and business model can be easily controlled by the content provider.',
        'service_jumbotron_03_text': 'Significantly reduce operating costs through simultaneous distribution, monetization, and reporting.',

        'service_point_01_title': 'Simultaneous distribution, monetization, and reporting',
        'service_point_01_text': 'Easily set up content + business, deliver to multiple media simultaneously, significantly reduce operating costs, and provide tools for listing revenue reports.',
        'service_point_02_title': 'Control your business model',
        'service_point_02_text': 'Monetize with various business models such as pre-roll video advertising.',
        'service_point_03_title': 'Digital Format',
        'service_point_03_text': 'LITEVIEW has a digital format technology, which makes it possible to save content as a digital image and play them easily anytime.<br/><br/>' +
            '<li>LITEDISC : Video Format</li>' +
            '<li>LITEBOOK : E-book Format</li>',

        'service_RIC_point_01': 'Overcome\nDegradation',
        'service_RIC_point_02': 'Small Size',
        'service_RIC_point_03': 'Encryption<br/>&<br/>Decryption',
        'service_RIC_point_04': 'Patents\ngranted',

        'service_RIC_text': 'Our service insists of RIC, the originally developed codemark.<br/>' +
            'It is the only digital image codemark, supporting Image Compression and Modification.',
        'service_RIC_poster_caption': '※ Examples of the RIC on digital images',

        'service_top_title_01': 'LITEVIEW for individual creators',
        'service_top_title_02': 'to support content monetization',
        'service_top_title_03': '',
        'service_top_subtitle_01': 'Anyone can easily design their own distribution service.',
        'service_top_subtitle_02': 'All content types supported.',
        'service_top_subtitle_03': 'No initial cost, no sales commission.',
        'service_top_link': 'Go to the LITEVIEW homepage',

        'service_about_title_01': 'The age of paying ',
        'service_about_title_02': 'to see valuable content',
        'service_about_message_01': 'It is now commonplace',
        'service_about_message_021': 'for viewers to pay for',
        'service_about_message_022': 'valuable digital content.',
        'service_about_message_031': 'If creators could have their',
        'service_about_message_032': 'own original distribution service',
        'service_about_message_04': 'Creators would be able to create more value more freely.',
        'service_about_message_05': 'LITEVIEW can make that world a reality.',

        'service_feature_header_title': 'Why LITEVIEW is chosen',
        'service_feature_011': 'You can create your own unique delivery service',
        'service_feature_012': '(You can open your original website and original application)',
        'service_feature_02': 'You can open your own service by entering simple information',
        'service_feature_03': 'No initial cost',
        'service_feature_04': 'No revenue sharing',
        'service_feature_051': 'No code makes it easy for anyone to manage the service',
        'service_feature_052': '(Registration of distribution content, setting of fees, and app/site design are all free)',

        'service_content_header_title': 'Able to deliver a variety of content',
        'service_content_header_text': 'LITEVIEW works with all types of digital content',
        'service_content_type_01': 'Video & Live Streaming',
        'service_content_type_02': 'Photo Books & Blogs',
        'service_content_type_03': 'Live Commerce',
        'service_content_type_04': 'Radio & Sound source',
        'service_content_type_05': 'Online handshake event',
        'service_content_type_06': 'Online Counseling',
        'service_content_type_07': 'Fan community',
        'service_content_type_08': 'Online education',
        'service_content_type_09': 'Online school',

        'news_back_to_list': 'Back',

        'team_jumbotron_title': 'Extensive Experience and Excellent Skills',
        'team_jumbotron_text': 'LITEVIEW, located in Tokyo, grows with members who have extensive experience regardless of nationality.<br />' +
            'Some are from major companies such as Samsung etc. <br/>Some have experience in exiting their start-up.<br/>' +
            '<br/>' +
            'We have secured funding from global companies and VC based on our business model,<br/> such as Dentsu, Samsung, LINE and so on.',

        'contact_company_address_section': 'Office',
        'contact_company_address_jp': 'Japan HQ',
        'contact_company_address_jp_address': '5-34-2 Shiba, Minato-ku, Tokyo, 108-0014',
        'contact_company_address_kr': 'Republic of Korea Branch',
        'contact_company_address_kr_address': '416, Hangang-daero, Jung-gu, Seoul, 04637',
        'contact_company_email_comment': 'Contact us if you need additional information about LITEVIEW, job inquiry, interview or business cooperation.',
        'contact_download_btn': 'Download',

        'job_jumbotron_title': 'We are looking for people to change the world with LITEVIEW.',
        'job_jumbotron_text': 'We are LITEVIEW Inc., an innovative startup accelerating our clients\' new business ventures and Digital Transformation (DX) at 1/100th the cost of traditional methods. We operate "LITEVIEW," a platform that allows for the one-stop, no-code construction of proprietary apps, websites, and management functions.<br/>' +
            '<br/>' +
            'Achieving profitability in the hundreds of millions within just three years of our service launch, we have now entered our "Second Founding Phase," expanding our organization across all positions this year. Would you like to join us in scaling up together in this rapidly growing environment?<br/>' +
            '<br/>' +
            '【Our Services】<br/>' +
            '<br/>' +
            '▼ LITEVIEW Frontier: Instant no-code MVP construction & low-budget operation for new businesses<br/>' +
            '<br/>' +
            '(Link: <a href="https://frontier.liteview.jp" target="_blank">https://frontier.liteview.jp</a>)<br/>' +
            '<br/>' +
            '▼ LITEVIEW Team: Instant low-budget construction of internal portals<br/>' +
            '<br/>' +
            '(Link: <a href="https://team.liteview.jp" target="_blank">https://team.liteview.jp</a>)<br/>' +
            '<br/>' +
            '◎ Please check the link below for more details about our company and the role: (Link: <a href="https://youtrust.jp/recruitment_posts/434f308fd0e5582005b8a0fe5116f6f4" target="_blank">https://youtrust.jp/recruitment_posts/434f308fd0e5582005b8a0fe5116f6f4</a>)<br/>' +
            '<br/>' +
            'If you are even slightly interested, we would be more than happy to have a "casual coffee chat" first! Please feel free to reach out to us anytime. ◎',
        'job_position_title': 'Roles',


        'alt_facebook_share': 'Facebookへ共有',
        'alt_twitter_share': 'Twitterへ共有',
        'alt_ios_enginner': 'iOS Engineer',
        'alt_and_enginner': 'Android Engineer',
        'alt_web_enginner': 'Web Engineer',
        'alt_server_enginner': 'Server Engineer',
        'alt_main_background': '背景',

        'link_ios_engineer': 'https://www.wantedly.com/projects/223929',
        'link_and_engineer': 'https://www.wantedly.com/projects/223932',
        'link_server_engineer': 'https://www.wantedly.com/projects/223920',
        'link_web_engineer': 'https://www.wantedly.com/projects/223933',

        'link_investor_zcaptial': 'https://zvc.vc/',
        'link_investor_line': 'https://lineventurescorp.com/en/',
        'link_investor_dentsu': 'http://www.dentsu.com/',
        'link_investor_dkgate': 'https://www.garage.co.jp/en/',
        'link_investor_bonangels': 'http://bonangels.net/',

        'footer_main_message': 'LITEVIEW finds a member to realize our vision together. \nWe can\'t wait for working with new members',
        'footer_main_btn': 'Roles',
        'footer_href_liteview': 'LITEVIEW will support your company\'s new business and digital transformation strategies. Please feel free to contact us.',
        'footer_contact_message': 'LITEVIEW will support your company\'s new business and digital transformation strategies. Please feel free to contact us.',
        'footer_liteview_btn': 'Go to the LITEVIEW website.',
        'footer_contact_btn': 'Contact Us',
        'footer_jobs_message': 'Free format resumes are welcome.\nPlease feel free to contact us.',
        'footer_jobs_btn': 'Contact',

        'error_name_required': 'Please fill out this field.',
        'error_email_required': 'Please fill out this field.',
        'error_email_type_mismatch': 'Please include an \'@\' in the email address.',
        'error_message_required': 'Please fill out this field.',
        'confirm_external_link': 'It will jump to an external page. Do you proceed?',

        'job_header_poster_01': 'Pull your idea and talent',
        'resources_logo': 'LITEVIEW',
        'resources_poster_01': 'Pull your idea and talent',
        'resources_poster_02': 'No Content, No Life',
        'resources_poster_03': 'Be the one',
        'resources_poster_04': 'Distribution new value',
        'service_device_01': 'Distribution',
        'service_device_02': 'Play',
        'service_device_03': 'Monetize',
        'service_point_01': 'Exclusive Player (Native App)',
        'service_point_02': 'Save as Image (in Photo App)',
        'service_point_03': 'Digital Format',
        'service_codemark': 'RIC (Robust Index Code)',
        'service_poster': 'Examples of the RIC on digital images',
        'investors_logo_01': 'Z Venture Capital',
        'investors_logo_02': 'DK Gate',
        'investors_logo_03': 'Bon Angels',
        'investors_logo_etc': 'And many others',

        'sns_tweet_url': 'https://twitter.com/intent/tweet?url=https%3A%2F%2Fpulit.jp&text=LITEVIEW+innovates+the+brand+new+Content+Distribution+Infra+%7C+LITEVIEW+Inc',
        'sns_share_url': 'https://facebook.com/sharer/sharer.php?app_id=113869198637480&sdk=joey&u=http%3A%2F%2Fpulit.jp%2F&display=popup&ref=plugin&src=share_button'
    }
});

export const SNSType = {
    Facebook: 1,
    Twitter: 2,
    Instagram: 3,
    LinkedIn: 4
};

const leeSNS = [
    {
        type: SNSType.Facebook,
        url: 'https://www.facebook.com/halkw'
    }
];
const kimSNS = [
    {
        type: SNSType.Facebook,
        url: 'https://www.facebook.com/minsu513'
    },
    {
        type: SNSType.LinkedIn,
        url: 'https://www.linkedin.com/in/minsu-kim-61ab93b2'
    },
];
const yamaguchiSNS = [];
const babaSNS = [];
const leeHayeonSNS = [];
const nishimotoSNS = [];
const ishijimaSNS = [];
const kimyuheeSNS = [];
const yooyeerangSNS = [];
const leebomiSNS = [];

export let lMembers = new LocalizedStrings({
    ja: {
        'member_1_name': 'K.W Lee',
        'member_1_src': './img/members/member_klee.png',
        'member_1_srcset': './img/members/member_lee.png 1x, ./img/members/member_lee@2x.png 2x, ./img/members/member_lee@3x.png 3x',
        'member_1_title': 'CEO',
        'member_1_desc': '東京工業大学大学院修士了。約9年間、Samsung Electronicsなどにて研究開発に参画後、LITEVIEW社を起業。開発業務以外には、海外法人(欧州、日本)で人事やマーケター業務を経験。',
        'member_1_sns': leeSNS,

        'member_2_name': '馬場 稔正',
        'member_2_src': './img/members/member_baba.png',
        'member_2_srcset': './img/members/member_baba.png 1x, ./img/members/member_baba@2x.png 2x, ./img/members/member_baba@3x.png 3x',
        'member_2_title': '取締役',
        'member_2_desc': 'ウェールズ大学経営大学院修士了。2000年 東大出身の医師とセブンデイズクリニックを創業（現医療法人社団優人会）、メディカルリサーチアンドテクノロジー（現MRT）に経営参画。2010年 MRT株式会社代表取締役社長に就任、2014年 MRT株式会社は東証マザーズ上場へ。2015年 ABABA株式会社創業。2019年 再生医療テクノロジー株式会社創業。2021年 インフルエンサーZ株式会社創業。2022年LITEVIEW株式会社に参画。',
        'member_2_sns': babaSNS,

        'member_3_name': '山口 豪志',
        'member_3_src': './img/members/member_yamaguchi.png',
        'member_3_srcset': './img/members/member_yamaguchi.png 1x, ./img/members/member_yamaguchi@2x.png 2x, ./img/members/member_yamaguchi@3x.png 3x',
        'member_3_title': '取締役',
        'member_3_desc': '茨城大学理学部卒。クックパッド株式会社にて、広告事業・マーケティング事業の創成期より参加、2009年の同社IPOにトップセールスにて貢献。12年より3人目の社員としてランサーズ株式会社に参画し、約3年の在籍期間中に事業を急成長させる。2015年5月にベンチャー支援を強化するために株式会社５４を創業。2022年LITEVIEW株式会社に参画。',
        'member_3_sns': yamaguchiSNS,

        'member_4_name': 'キム ミンス',
        'member_4_src': './img/members/member_ross.png',
        'member_4_srcset': './img/members/member_ross.png 1x, ./img/members/member_ross@2x.png 2x, ./img/members/member_ross@3x.png 3x',
        'member_4_title': 'CTO',
        'member_4_desc': '東京工業大学工学部情報工学科を早期卒業、現在は博士課程。フリーランスとして6年間、複数のベンチャー企業にて、web、iOS、AndroidのアプリケーションやSCMを開発・設計。LITEVIEW社では、開発業務全般を担当。',
        'member_4_sns': kimSNS,

        'member_6_name': 'イ ハヨン',
        'member_6_src': './img/members/member_LeeHayeon.png',
        'member_6_srcset': './img/members/member_LeeHayeon.png 1x, ./img/members/member_LeeHayeon@2x.png 2x, ./img/members/member_LeeHayeon@3x.png 3x',
        'member_6_title': 'Engineer',
        'member_6_desc': '「42 seoul」、「Wanted Pre-OnBoardingコース」に参加し、iOSエンジニアとして活躍。2022年よりLITEVIEW社に参画。',
        'member_6_sns': leeHayeonSNS,

        'member_7_name': '石島 麗子',
        'member_7_src': './img/members/member_ishijima.png',
        'member_7_srcset': './img/members/member_ishijima.png 1x, ./img/members/member_ishijima@2x.png 2x, ./img/members/member_ishijima@3x.png 3x',
        'member_7_title': '広報・採用担当',
        'member_7_desc': '一貫して人の“働く“に携わる業務に従事。新卒時よりリクルート社にて法人営業・採用コンサルティング・「リクナビ」の編集デスクを行ったのち、ランサーズ社にて広報を担当。その後、総合人材サービスを提供するICONICグループにて国をまたいだグループ人事・広報・キャリアコンサルティングを担い、LITEVIEW社へJoin。',
        'member_7_sns': ishijimaSNS,

        'member_10_name': '西本 匡',
        'member_10_src': './img/members/member_nishimoto.png',
        'member_10_srcset': './img/members/member_nishimoto.png 1x, ./img/members/member_nishimoto@2x.png 2x, ./img/members/member_nishimoto@3x.png 3x',
        'member_10_title': '営業',
        'member_10_desc': '中国吉林大学法学部卒。日・中・英を話すトリリンガル。北京市法律事務所、飲食・福祉チェーン、中国系広告代理店、スポーツ機器メーカーなど多様な経歴から、LITEVIEWの各業界での使用シーンを想像しながら営業としてご提案を行う。',
        'member_10_sns': nishimotoSNS,

        'member_11_name': 'キム ユヒ',
        'member_11_src': './img/members/member_kimyuhee.png',
        'member_11_srcset': './img/members/member_kimyuhee.png 1x, ./img/members/member_kimyuhee@2x.png 2x, ./img/members/member_kimyuhee@3x.png 3x',
        'member_11_title': 'Engineer',
        'member_11_desc': '東亜大学コンピュータ工学科卒業。Android開発に興味を持ち、「wanted preonboardingコース」に参加し、Android開発者として成長。2023年LITEVIEWにAndroid Engineerとして入社。',
        'member_11_sns': kimyuheeSNS,

        'member_12_name': 'ユ イラン',
        'member_12_src': './img/members/member_yooyeerang.png',
        'member_12_srcset': './img/members/member_yooyeerang.png 1x, ./img/members/member_yooyeerang@2x.png 2x, ./img/members/member_yooyeerang@3x.png 3x',
        'member_12_title': 'Designer',
        'member_12_desc': 'スタートアップと大手企業で多数のUI/UXプロジェクトをリード。ポスコ、LG、ハンファなど60件以上のプロジェクト遂行。グローバル企業で国内外クライアント向けUXコンサルティングを経験するなど、マルチ分野でのデザイン専門性を積み、2024年LITEVIEWに入社。',
        'member_12_sns': yooyeerangSNS,

        'member_13_name': 'イ　ボミ',
        'member_13_src': './img/members/member_leebomi.png',
        'member_13_srcset': './img/members/member_leebomi.png 1x, ./img/members/member_leebomi@2x.png 2x, ./img/members/member_leebomi@3x.png 3x',
        'member_13_title': 'Engineer',
        'member_13_desc': '大学でファインアートを専攻、Web形式の作品を制作したことをきっかけにEngineerに転向。 2024年LITEVIEWにServer&Web Engineerとして入社。',
        'member_13_sns': leebomiSNS,

        'techmember_1_name': '権藤 克彦',
        'techmember_1_src': '',
        'techmember_1_title': '東京工業大学 学術国際情報センター 教授',
        'techmember_1_desc': '東京工業大学理工学研究科情報工学専攻博士課程修了(1994年)。2010年、東京工業大学大学院学術国際情報センター教授就任。現在、学会誌コンピュータソフトウェア編集委員,SPAプログラム委員に所属。LITEVIEW社の特許技術(LITEPLAY)開発に、大学での研究初期段階から技術アドバイザーとして参加。',


        'stramember_1_name': '成松 淳',
        'stramember_1_src': '',
        'stramember_1_title': 'ミューゼオ株式会社 代表取締役CEO',
        'stramember_1_desc': '監査法人トーマツを経て東京証券取引所上場部に出向、上場規則等の整備や上場規則上の措置適用等に従事。2007年よりクックパッド株式会社執行役CFOとして管理体制の構築、東証マザーズ上場等を主導し、2012年３月に独立のため退任。現在はネットサービスの運営に注力するほか、エンジェル投資や社外役員としての立場からベンチャー支援にも携わる。',

        'stramember_2_name': '佐藤 裕介',
        'stramember_2_src': '',
        'stramember_2_title': ['STORES株式会社 代表取締役社長', '株式会社フリークアウト・ホールディングス 取締役'],
        'stramember_2_desc': '2008年、Googleに入社し、広告製品を担当。2010年末、COOとしてフリークアウトの創業に参画。また、株式会社イグニスにも取締役として参画し、2014年6月にはフリークアウト、イグニス共にマザーズ上場。2017年1月、フリークアウト・ホールディングス共同代表に就任。エンジェル投資家としても活動。',

        'stramember_3_name': '加藤 寛之',
        'stramember_3_src': '',
        'stramember_3_title': '株式会社イロドリ 代表取締役CEO',
        'stramember_3_desc': '東京大学を卒業後、2008年4月より株式会社アトランティス社（後にGREE社へ売却）に最高技術責任者として参画。株式会社ネットプライスドットコムにてR&D業務、技術者としての知識/経験を活かした関連会社の業務改善、及び新規事業の企画及び立ち上げを行う。2014年3月に株式会社イロドリを設立し代表取締役社長に就任。 現在に至る。',

        'stramember_4_name': '山口 豪志',
        'stramember_4_src': '',
        'stramember_4_title': ['プロトスター株式会社 代表取締役COO', '株式会社54 代表取締役社長'],
        'stramember_4_desc': '茨城大学理学部卒。クックパッド株式会社にて、広告事業・マーケティング事業の創成期より参加、2009年の同社IPOにトップセールスにて貢献。12年より3人目の社員としてランサーズ株式会社に参画し、約3年の在籍期間中に事業を急成長させる。2015年5月にベンチャー支援を強化するために株式会社５４を創業。2017年7月よりプロトスター社へ参画。',

        'legalmember_1_name': '松田 良成',
        'legalmember_1_src': '',
        'legalmember_1_title': ['弁護士法人漆間総合法律事務所 所長弁護士'],
        'legalmember_1_desc': '弁護士法人漆間総合法律事務所の所長を務め、わずか２年で同事務所を中規模M&Aマーケットにおける取扱い件数国内トップ６位の事務所へ成長させる（トムソン・ロイター調べ）。年間で6件以上のM＆A取引実行の実績がある他、バイオ関連企業を含む上場・非上場会社の法務顧問を多く務めるほか、資金調達案件・企業買収案件などに数々の実績を残す。',
    },
    ko: {
        'member_1_name': '이건우',
        'member_1_src': './img/members/member_kwlee.png',
        'member_1_srcset': './img/members/member_kwlee.png 1x, ./img/members/member_kwlee@2x.png 2x, ./img/members/member_kwlee@3x.png 3x',
        'member_1_title': 'CEO',
        'member_1_desc': '동경공업대학대학원 석사. 약 9년간 삼성전자 등에서 재직한 후 LITEVIEW을 설립. 개발 업무 이외에도 해외 법인(유럽, 일본)에서 인사와 마케터 업무를 경험.',
        'member_1_sns': leeSNS,

        'member_2_name': 'Toshimasa Baba',
        'member_2_src': './img/members/member_baba.png',
        'member_2_srcset': './img/members/member_baba.png 1x, ./img/members/member_baba@2x.png 2x, ./img/members/member_baba@3x.png 3x',
        'member_2_title': '이사',
        'member_2_desc': '웨일스 대학 경영 대학원 석사 과정 수료.2000년 도쿄대 출신의 의사와 세븐데이즈 클리닉을 창업(현 의료법인 사단우인회), 메디컬 리서치앤테크놀로지(현 MRT)에 경영 참가.2010년 MRT 주식회사 대표이사 사장에 취임, 2014년 MRT 주식회사는 도쿄증권 마더스 상장에.2015년 ABABA 주식회사 창업.2019년 재생의료테크놀로지주식회사 창업.2021년 인플루언서Z 주식회사 창업.2022년 LITEVIEW 주식회사 참여.',
        'member_2_sns': babaSNS,

        'member_3_name': 'Goshi Yamaguchi',
        'member_3_src': './img/members/member_yamaguchi.png',
        'member_3_srcset': './img/members/member_yamaguchi.png 1x, ./img/members/member_yamaguchi@2x.png 2x, ./img/members/member_yamaguchi@3x.png 3x',
        'member_3_title': '이사',
        'member_3_desc': '이바라키 대학 이학부 졸업. 쿡패드 주식회사에서 광고 사업·마케팅 사업의 창성기부터 참가, 2009년의 동사 IPO에 톱 세일즈로 공헌. 12년부터 3번째 사원으로서 랜서스 주식회사에 참가해, 약 3년의 재적 기간중에 사업을 급성장시킨다.2015년 5월에 벤처 지원을 강화하기 위해서 주식회사 54를 창업.2022년 LITEVIEW 주식회사 참여.',
        'member_3_sns': yamaguchiSNS,

        'member_4_name': '김민수',
        'member_4_src': './img/members/member_ross.png',
        'member_4_srcset': './img/members/member_ross.png 1x, ./img/members/member_ross@2x.png 2x, ./img/members/member_ross@3x.png 3x',
        'member_4_title': 'CTO',
        'member_4_desc': '동경공업대학 정보공학과를 조기 졸업한 후 현재는 박사과정. 프리랜서로서 약 6년간 다양한 벤처 기업에서 Web, iOS, Android 등의 응용 프로그램 및 SCM을 개발. LITEVIEW을 공동 설립하여 현재 개발 총 책임자.',
        'member_4_sns': kimSNS,

        'member_6_name': '이하연',
        'member_6_src': './img/members/member_LeeHayeon.png',
        'member_6_srcset': './img/members/member_LeeHayeon.png 1x, ./img/members/member_LeeHayeon@2x.png 2x, ./img/members/member_LeeHayeon@3x.png 3x',
        'member_6_title': 'Engineer',
        'member_6_desc': '‘42seoul’, ‘wanted preonboarding 코스’에 참여하여 iOS 개발자로 성장. 2022년부터 LITEVIEW에 입사.',
        'member_6_sns': leeHayeonSNS,

        'member_7_name': 'Reiko Ishijima',
        'member_7_src': './img/members/member_ishijima.png',
        'member_7_srcset': './img/members/member_ishijima.png 1x, ./img/members/member_ishijima@2x.png 2x, ./img/members/member_ishijima@3x.png 3x',
        'member_7_title': '홍보·채용 담당',
        'member_7_desc': '일관되게 사람의 "일하기"에 종사하는 업무를 담당. 신입 때부터 Recruit Co.에서 법인 영업·채용 컨설팅·「리쿠나비」의 편집 데스크를 담당한 후, Lancers Inc.에서 홍보를 담당. 그 후, 종합 인재 서비스를 제공하는 ICONIC 그룹에서 글로벌한 그룹 인사·홍보·캐리어 컨설팅을 담당해, LITEVIEW사에 Join.',
        'member_7_sns': ishijimaSNS,

        'member_10_name': 'Tadashi Nishimoto',
        'member_10_src': './img/members/member_nishimoto.png',
        'member_10_srcset': './img/members/member_nishimoto.png 1x, ./img/members/member_nishimoto@2x.png 2x, ./img/members/member_nishimoto@3x.png 3x',
        'member_10_title': 'Sales',
        'member_10_desc': '중국 지린대학교 법대졸. 일·중·영을 말하는 트릴링걸. 베이징시 법률사무소, 음식·복지 체인, 중국계 광고대행사, 스포츠기기 제조업체 등 다양한 경력에서 LITEVIEW의 각 업계 사용 장면을 상상하며 영업으로 제안한다.',
        'member_10_sns': nishimotoSNS,

        'member_11_name': '김유희',
        'member_11_src': './img/members/member_kimyuhee.png',
        'member_11_srcset': './img/members/member_kimyuhee.png 1x, ./img/members/member_kimyuhee@2x.png 2x, ./img/members/member_kimyuhee@3x.png 3x',
        'member_11_title': 'Engineer',
        'member_11_desc': '동아대학교 컴퓨터공학과 졸업. Android 개발에 관심을 갖고 \'wanted preonboarding 코스\' 에 참여하며 Android 개발자로 성장. 2023년 LITEVIEW에 Android Engineer로 입사.',
        'member_11_sns': kimyuheeSNS,

        'member_12_name': '유이랑',
        'member_12_src': './img/members/member_yooyeerang.png',
        'member_12_srcset': './img/members/member_yooyeerang.png 1x, ./img/members/member_yooyeerang@2x.png 2x, ./img/members/member_yooyeerang@3x.png 3x',
        'member_12_title': 'Designer',
        'member_12_desc': '스타트업과 대기업에서 다수의 UI/UX 프로젝트를 리드. 포스코, LG, 한화 등 60건 이상 프로젝트 수행. 글로벌 기업에서 국내외 클라이언트 대상 UX 컨설팅을 경험하는 등, 다양한 도메인 산업군에서의 디자인 전문성을 쌓아, 2024년 LITEVIEW에 입사.',
        'member_12_sns': yooyeerangSNS,

        'member_13_name': '이보미',
        'member_13_src': './img/members/member_leebomi.png',
        'member_13_srcset': './img/members/member_leebomi.png 1x, ./img/members/member_leebomi@2x.png 2x, ./img/members/member_leebomi@3x.png 3x',
        'member_13_title': 'Engineer',
        'member_13_desc': '대학에서 순수미술을 전공, 웹 형식의 작품 제작을 계기로 개발자로 전향했다. 2024년 LITEVIEW에 Server&Web Engineer로 입사.',
        'member_13_sns': leebomiSNS,

        'techmember_1_name': 'Katsuhiko Gondow',
        'techmember_1_src': '',
        'techmember_1_title': '동경공업대학 학술국제정보센터 교수',
        'techmember_1_desc': '동경공업대학 이공학연구과 정보공학전공 박사과정 수료 (1994 년). 2010년 동경공업대학대학원 학술국제정보센터 교수 취임. 현재 컴퓨터 소프트웨어 학회지 편집 위원, SPA 프로그램위원회 소속. LITEVIEW의 특허기술(LITEPLAY)에 연구 초기 단계부터 기술 고문으로 참여.',

        'stramember_1_name': 'Jun Narimatsu',
        'stramember_1_src': '',
        'stramember_1_title': 'Muuseo 주식회사 CEO',
        'stramember_1_desc': '감사법인 토마츠를 거쳐 도쿄증권거래소 상장부에 파견되어 상장 규칙 제정 등의 업무에 종사. 2007년부터 Cookpad 주식회사의 CFO로서 도쿄증권거래소의 마더스 상장을 주도하고, 2012년 독립을 위해 퇴임. 현재는 인터넷 서비스 운영에 주력하면서 엔젤 투자 및 사외 이사로서 벤처회사들을 지원중.',

        'stramember_2_name': 'Yusuke Sato',
        'stramember_2_src': '',
        'stramember_2_title': ['hey 주식회사 CEO', 'FreakOut Holdings 주식회사 이사'],
        'stramember_2_desc': '2008년 Google에 입사하여 광고제품을 담당. 2010년 FreakOut, IGNIS의 창업에 참여, 이사로 활동. 2014년 6월에 각각 도쿄증권거래소 마더스 상장. 2017년 1월에 FreakOut Holdings 공동대표에 취임. 엔젤 투자가로서 활동.',

        'stramember_3_name': 'Hiroyuki Kato',
        'stramember_3_src': '',
        'stramember_3_title': 'irodori 주식회사 CEO',
        'stramember_3_desc': '도쿄대 졸업 후 2008년부터 주식회사 아틀란티스(후에 GREE 사에 매각)의 CTO로 참여. 주식회사 Netprice에서 R&D 업무를 진행하며 기술자로서의 지식과 경험을 살려 신규 사업을 기획하고 출시. 2014년 주식회사 irodori를 설립하여 CEO로서 사업 진행중.',

        'stramember_4_name': 'Goshi Yamaguchi',
        'stramember_4_src': '',
        'stramember_4_title': ['Protostar 주식회사 COO', '54 주식회사 CEO'],
        'stramember_4_desc': '이바라키대학 이학부 졸업. Cookpad 주식회사에서 광고 및 마케팅 사업에 초창기부터 참여하여 2009년 IPO에 기여. 2012년 3번째 사원으로서 Lancers 주식회사에 참여하여 약 3년간 사업의 급성장에 기여. 2015년 5월에 벤처회사들을 지원하는 54 주식회사를 설립. 2017년 7월부터 Protostar 주식회사에 참여.',

        'legalmember_1_name': 'Yoshinari Matsuda',
        'legalmember_1_src': '',
        'legalmember_1_title': ['변호사법인 우루마종합법률사무소 소장 변호사'],
        'legalmember_1_desc': '변호사법인 우루마종합법률사무소의 소장을 맡아 2년만에 중소기업 M&A 시장에서 취급 건수 일본내 상위 6위의 사무소로 성장시킴(톰슨・로이터 조사). 연간 6건 이상의 M&A 거래 수행 실적이있고, 바이오 관련 기업을 포함하여 상장/비상장 회사의 법률 고문을 맡아 자금조달 자문, 기업의 인수 안건 등에서 많은 실적 및 성과가 있음.',
    },
    en: {
        'member_1_name': 'K.W Lee',
        'member_1_src': './img/members/member_kwlee.png',
        'member_1_srcset': './img/members/member_kwlee.png 1x, ./img/members/member_kwlee@2x.png 2x, ./img/members/member_kwlee@3x.png 3x',
        'member_1_title': 'CEO',
        'member_1_desc': 'M.S. in Tokyo Institute of Technology. Co-founded LITEVIEW after 9 years work on Samsung and other companies. In addition to development, worked on the department of human resources and marketing in foreign companies (Europe, Japan).',
        'member_1_sns': leeSNS,

        'member_2_name': 'Toshimasa Baba',
        'member_2_src': './img/members/member_baba.png',
        'member_2_srcset': './img/members/member_baba.png 1x, ./img/members/member_baba@2x.png 2x, ./img/members/member_baba@3x.png 3x',
        'member_2_title': 'Board Member',
        'member_2_desc': 'Completed Master\'s program at the University of Wales Graduate School of Management. 2000 Founded Seven Days Clinic with a doctor from the University of Tokyo (now Yuhinkai Medical Corporation) and participated in the management of Medical Research and Technology (now MRT). 2010: Appointed as President and Representative Director of MRT Co. 2014 MRT Corporation was listed on the Tokyo Stock Exchange Mothers.2015 Founded ABABA Corporation. 2019 Founded Regenerative Medicine Technology Co. 2021 Founded Influencer Z Corporation',
        'member_2_sns': babaSNS,

        'member_3_name': 'Goshi Yamaguchi',
        'member_3_src': './img/members/member_yamaguchi.png',
        'member_3_srcset': './img/members/member_yamaguchi.png 1x, ./img/members/member_yamaguchi@2x.png 2x, ./img/members/member_yamaguchi@3x.png 3x',
        'member_3_title': 'Board Member',
        'member_3_desc': 'Graduated from Ibaraki University, Faculty of Science. 2007 Joined COOKPAD Inc. and contributed as a top sales person 2009 COOKPAD Inc. was listed on the Tokyo Stock Exchange\'s Mothers market. 2012 Joined REIT Inc. (now Lancers Inc.), where he served as the Director of Business Development and Head of Public Relations 2015 Founded 54 Inc. 2017 Joined Protostar Inc. as Representative Director and President 2018 Founded Protostar Hong Kong Ltd. and assumed the position of Representative 2020 Appointed full-time director of Leaver Inc. 2021 Appointed as advisor of both Change the World Inc. and Digital Stage Inc.',
        'member_3_sns': yamaguchiSNS,

        'member_4_name': 'Minsu Kim',
        'member_4_src': './img/members/member_ross.png',
        'member_4_srcset': './img/members/member_ross.png 1x, ./img/members/member_ross@2x.png 2x, ./img/members/member_ross@3x.png 3x',
        'member_4_title': 'CTO',
        'member_4_desc': 'M.S. and Ph.D. candidate in Tokyo Institute of Technology after early graduated B.S. Developed Web, iOS, Android applications on some ventures as a freelancer for 6 years. Co-founder & CTO of LITEVIEW in now.',
        'member_4_sns': kimSNS,

        'member_6_name': 'Hayeon Lee',
        'member_6_src': './img/members/member_LeeHayeon.png',
        'member_6_srcset': './img/members/member_LeeHayeon.png 1x, ./img/members/member_LeeHayeon@2x.png 2x, ./img/members/member_LeeHayeon@3x.png 3x',
        'member_6_title': 'Engineer',
        'member_6_desc': 'Participated in "42 seoul" and "Wanted Pre-OnBoarding Course" as an iOS Engineer, joined LITEVIEW in 2022.',
        'member_6_sns': leeHayeonSNS,

        'member_7_name': 'Reiko Ishijima',
        'member_7_src': './img/members/member_ishijima.png',
        'member_7_srcset': './img/members/member_ishijima.png 1x, ./img/members/member_ishijima@2x.png 2x, ./img/members/member_ishijima@3x.png 3x',
        'member_7_title': 'Public Relations and Recruitment',
        'member_7_desc': 'I have been consistently engaged in work related to people\'s "work".After graduating from Recruit Co., Ltd. he worked in corporate sales, recruitment consulting, and on the editorial desk of "Riku Navi" before joining Lancers, Inc. in charge of public relations.After that, I worked for ICONIC Group, a comprehensive human resource service provider, where I was in charge of group HR, PR, and career consulting across countries before joining LITEVIEW.',
        'member_7_sns': ishijimaSNS,

        'member_10_name': 'Tadashi Nishimoto',
        'member_10_src': './img/members/member_nishimoto.png',
        'member_10_srcset': './img/members/member_nishimoto.png 1x, ./img/members/member_nishimoto@2x.png 2x, ./img/members/member_nishimoto@3x.png 3x',
        'member_10_title': 'Sales',
        'member_10_desc': 'Graduated from the Faculty of Law, Jilin University, China. Trilingual in Japanese, Chinese and English. With a diverse background including a Beijing law firm, a restaurant and welfare chain, a Chinese advertising agency, and a sports equipment manufacturer, she makes proposals as a sales representative while imagining the usage scenarios of LITEVIEW in various industries.',
        'member_10_sns': nishimotoSNS,

        'member_11_name': 'Kim Yuhee',
        'member_11_src': './img/members/member_kimyuhee.png',
        'member_11_srcset': './img/members/member_kimyuhee.png 1x, ./img/members/member_kimyuhee@2x.png 2x, ./img/members/member_kimyuhee@3x.png 3x',
        'member_11_title': 'Engineer',
        'member_11_desc': 'Graduated from Dong-A University, Department of Computer Science. Interested in Android development and participated in the \'wanted preonboarding course\' to grow as an Android developer. Joined LITEVIEW as an Android Engineer in 2023.',
        'member_11_sns': kimyuheeSNS,

        'member_12_name': 'Yoo Yeerang',
        'member_12_src': './img/members/member_yooyeerang.png',
        'member_12_srcset': './img/members/member_yooyeerang.png 1x, ./img/members/member_yooyeerang@2x.png 2x, ./img/members/member_yooyeerang@3x.png 3x',
        'member_12_title': 'Designer',
        'member_12_desc': 'Leading multiple UI/UX projects at startups and large corporations. Performed more than 60 projects including POSCO, LG, and Hanwha. Having Accumulated design expertise in various domain industries, including experience in UX consulting for domestic and international clients at global companies. Joined LITEVIEW in 2024.',
        'member_12_sns': yooyeerangSNS,

        'member_13_name': 'Lee Bomi',
        'member_13_src': './img/members/member_leebomi.png',
        'member_13_srcset': './img/members/member_leebomi.png 1x, ./img/members/member_leebomi@2x.png 2x, ./img/members/member_leebomi@3x.png 3x',
        'member_13_title': 'Engineer',
        'member_13_desc': 'Majored in Fine Arts in university and turned to engineering after experiencing web-based art. Joined LITEVIEW in 2024 as a Server & Web Engineer.',
        'member_13_sns': leebomiSNS,

        'techmember_1_name': 'Katsuhiko Gondow',
        'techmember_1_src': '',
        'techmember_1_title': 'Professor of Tokyo Institute of Technology in Computer Science.',
        'techmember_1_desc': 'Ph.D. in Tokyo Institute of Technology in 1994. Took office as a professor in Tokyo Tech in 2010. Advised the LITEVIEW\'s patent research (LITEPLAY) from the first stage.',


        'stramember_1_name': 'Jun Narimatsu',
        'stramember_1_src': '',
        'stramember_1_title': 'Muuseo Inc. CEO',
        'stramember_1_desc': 'Worked with making rules of the stock market in Tokyo Stock Exchange dispatched from Audit corporation Tomatsu. Joined as CFO in Cookpad Inc. in 2007, raised IPO, retired in 2012. Supports some ventures as an outside director and angle investor in now.',

        'stramember_2_name': 'Yusuke Sato',
        'stramember_2_src': '',
        'stramember_2_title': ['hey Inc. CEO', 'FreakOut Holdings Inc. CEO'],
        'stramember_2_desc': 'Joined Google Japan and worked in the advertise & marketing. Found FreakOut as COO in 2010 and also charged as a director in IGNIS. They got listed on TSE Mothers on June 2014. Engaged a director in FreakOut Holdings Inc on Jan 2017. Working as an angle investor.',

        'stramember_3_name': 'Hiroyuki Kato',
        'stramember_3_src': '',
        'stramember_3_title': 'irodori Inc. CEO',
        'stramember_3_desc': 'Joined as CTO on Atlantis Co., Ltd in 2008 after graduating Tokyo University, which was exited to GREE Inc. Planned and released a new project as a R&D engineer in netprice, Ltd. Found irodori Inc. in 2014 and managing the company as CEO.',

        'stramember_4_name': 'Goshi Yamaguchi',
        'stramember_4_src': '',
        'stramember_4_title': ['Protostar Inc. COO', '54 corp. CEO'],
        'stramember_4_desc': 'B.S. in Ibaraki University. Joined Cookpad Inc. since Foundation and raised IPO in 2009. Contributed the growth of the business as the third member on Lancers Inc. in 2012. Found 54 corp. on May 2015 to support ventures. Joined Protostar Inc. on July 2017.',

        'legalmember_1_name': 'Yoshinari Matsuda',
        'legalmember_1_src': '',
        'legalmember_1_title': ['Senior managing partner of Uruma law offices legal professional corporation'],
        'legalmember_1_desc': 'Attorney at law directing Uruma Law Offices Legal Professional Corporation. has grown the office to the top six domestic offices handled in medium-sized M&A market in just two years. (According to Thomson Reuters) In addition to having over 6 M&A transactions annually, achieved lots of projects such as fund-raising and corporate acquisition as a legal counselor for listed and unlisted companies including bio-related companies',
    }
});

export const NewsType = {
    Job: {
        text: 'Job',
        class: 'job',
    },
    Member: {
        text: 'Member',
        class: 'member',
    },
    PressRelease: {
        text: 'Press Release',
        class: 'pr',
    },
    Media: {
        text: 'Media',
        class: 'pr',
    },
    Team: {
        text: 'Team',
        class: 'team',
    },
    News: {
        text: 'News',
        class: 'news',
    },
    Other: {
        text: 'Other',
        class: 'other',
    }
};

export function categoryToNewsType(category) {
    switch (category) {
        case 1:
            return NewsType.Job;
        case 2:
            return NewsType.Member;
        case 3:
            return NewsType.PressRelease;
        case 4:
            return NewsType.Media;
        case 5:
            return NewsType.Team;
        case 6:
            return NewsType.News;
        case 7:
            return NewsType.Other;
        default:
            return NewsType.PressRelease;
    }
}

export const NewsSize = 41;
export let lNews = new LocalizedStrings({
    ja: {
        '-1': {
            category: NewsType.Job,
            title: 'LITEVIEWと一緒に世界を変える\n' +
                '仲間を募集しています。\n' +
                'インターン',
            date: 'January 3, 2026',
            thumbnail: './img/news/job/card-intern-v1.png',
            thumbnailSet: './img/news/job/card-intern-v1.png 1x, ./img/news/job/card-intern-v1@2x.png 2x, ./img/news/job/card-intern-v1@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './jobs'
        },
        0: {
            category: NewsType.Job,
            title: 'LITEVIEWと一緒に世界を変える\n' +
                '仲間を募集しています。\n' +
                '正社員\n' +
                '（エンジニア / PRブランディング\n' +
                '/ マーケティング）',
            date: 'January 3, 2026',
            thumbnail: './img/news/job/cardv2.png',
            thumbnailSet: './img/news/job/cardv2.png 1x, ./img/news/job/cardv2@2x.png 2x, ./img/news/job/cardv2@3x.png 3x',
            internalLink: './jobs'
        },
        2: {
            category: NewsType.PressRelease,
            title: '弊社のシードラウンドで総額5,000万円の資金を調達しました',
            date: 'July 26, 2016',
            thumbnail: './img/news/1/card.png',
            thumbnailSet: './img/news/2/card.png 1x, ./img/news/2/card@2x.png 2x, ./img/news/2/card@3x.png 3x',
            externalLink: 'https://www.wantedly.com/companies/pulit/post_articles/129728'
        },
        3: {
            category: NewsType.PressRelease,
            title: '弊社のプレシリーズAラウンドで総額1億円の資金を調達しました',
            date: 'June 21, 2017',
            thumbnail: './img/news/3/card.png',
            thumbnailSet: './img/news/3/card.png 1x, ./img/news/3/card@2x.png 2x, ./img/news/3/card@3x.png 3x',
            externalLink: 'https://www.wantedly.com/companies/pulit/post_articles/129769'
        },
        5: {
            category: NewsType.PressRelease,
            title: '弊社のシリーズAラウンドで資金を調達しました（サムスン、LINE参加）',
            date: 'June 26, 2018',
            thumbnail: './img/news/5/card.png',
            thumbnailSet: './img/news/5/card.png 1x, ./img/news/5/card@2x.png 2x, ./img/news/5/card@3x.png 3x',
            externalLink: 'https://www.wantedly.com/companies/pulit/post_articles/129771'
        },
        14: {
            category: NewsType.PressRelease,
            title: 'LITEVIEWのβ版サービスがリリースされました',
            date: 'February 28, 2019',
            thumbnail: './img/news/14/card.png',
            thumbnailSet: './img/news/14/card.png 1x, ./img/news/14/card@2x.png 2x, ./img/news/14/card@3x.png 3x',
            externalLink: 'https://www.wantedly.com/companies/pulit/post_articles/159870',
            internalLink: undefined
        },
        27: {
            category: NewsType.PressRelease,
            title: '配信サービスを誰でもカンタンに設計できる「LITEVIEW」βサービス開始',
            date: 'July 1, 2021',
            thumbnail: './img/news/27/card.png',
            thumbnailSet: './img/news/27/card.png 1x, ./img/news/27/card@2x.png 2x, ./img/news/27/card@3x.png 3x',
            externalLink: 'https://www.wantedly.com/companies/pulit/post_articles/370349',
            internalLink: undefined,
            text: '東京を拠点とするPulitは、動画やデジタル画像のコンテンツ流通技術の開発で得た知見と技術力を元に、クリエイターが独自の配信サービスをカンタンに設計できる「LITEVIEW」のβ版のサービスを開始いたしました。'
        },
        28: {
            category: NewsType.PressRelease,
            title: 'コンテンツ流通技術のLITEVIEW、シリーズBでKB Investmentから調達——エンジニアやビジネス開発人材確保に注力',
            date: 'January 1, 2022',
            thumbnail: './img/news/28/card.png',
            thumbnailSet: './img/news/28/card.png 1x, ./img/news/28/card@2x.png 2x, ./img/news/28/card@3x.png 3x',
            externalLink: 'https://www.wantedly.com/companies/pulit/post_articles/370356',
            internalLink: undefined,
            text: '東京を拠点とし、動画やデジタル画像のコンテンツ流通技術を開発する Pulit は、シリーズBラウンドで資金調達を実施したことを明らかにした。調達先は KB Investment。'
        },
        29: {
            category: NewsType.PressRelease,
            title: '【社名変更と資金調達のお知らせ】Pulit株式会社からLITEVIEW株式会社へ',
            date: 'June 1, 2022',
            thumbnail: './img/news/29/card.png',
            thumbnailSet: './img/news/29/card.png 1x, ./img/news/29/card@2x.png 2x, ./img/news/29/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/29',
            src: './md/cd_26_ja.md',
            text: 'この度、Pulit株式会社は2022年5月13日、LITEVIEW株式会社（ライトビュー株式会社）に社名変更いたしました。'
        },
        30: {
            category: NewsType.PressRelease,
            title: 'LITEVIEW株式会社のミッション「”フルタイムクリエイター”を増やす」とは？',
            date: 'June 3, 2022',
            thumbnail: './img/news/30/card.png',
            thumbnailSet: './img/news/30/card.png 1x, ./img/news/30/card@2x.png 2x, ./img/news/30/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/30',
            src: './md/cd_27_ja.md',
            text: '私たちLITEVIEW（ライトビュー）が掲げるミッションは、「”フルタイムクリエイター”を増やす」こと。'
        },
        31: {
            category: NewsType.PressRelease,
            title: 'LITEVIEWご利用事例：北斗晶さん・西山茉希さんによるライブコマース『ワケあって、数量限定ポキート！』',
            date: 'June 8, 2022',
            thumbnail: './img/news/31/card.png',
            thumbnailSet: './img/news/31/card.png 1x, ./img/news/31/card@2x.png 2x, ./img/news/31/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/31',
            src: './md/cd_28_ja.md',
            text: 'LITEVIEW（ライトビュー）はさまざまな方にご利用いただいていますが、タレントの北斗晶さん・西山茉希さんのライブコマース（ライブ配信によるオンライン販売）番組にもご活用いただいています！'
        },
        34: {
            category: NewsType.PressRelease,
            title: '新社外取締役に馬場 稔正氏、 山口 豪志氏の就任のお知らせ',
            date: 'August 3, 2022',
            thumbnail: './img/news/34/card.png',
            thumbnailSet: './img/news/34/card.png 1x, ./img/news/34/card@2x.png 2x, ./img/news/34/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/34',
            src: './md/cd_34_ja.md',
            text: 'LITEVIEW株式会社(本社:東京都港区、CEO:LEE KUNWOO)は、経営体制の強 化のため、馬場 稔正氏、山口 豪志氏の両名が社外取締役に就任したことをお知らせいたします。今回の役員体制の強化によりLITEVIEW株式会社は、「LITEVIEW(ライトビュー)」を通じて、より一層クリエイターの皆様の支えとなるサービスを提供できるよう取り組んでまいります。'
        },
        35: {
            category: NewsType.PressRelease,
            title: 'K-POP ガールズグループ「SECRET NUMBER」 公式ファンクラブサイトが本日オープン! LITEVIEW がシステム提供',
            date: 'August 8, 2022',
            thumbnail: './img/news/35/card.png',
            thumbnailSet: './img/news/35/card.png 1x, ./img/news/35/card@2x.png 2x, ./img/news/35/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/35',
            src: './md/cd_35_ja.md',
            text: 'クリエイターのためのコンテンツプラットフォームサービス「LITEVIEW(ライトビュー)」を開発・運営するLITEVIEW株式会社(本社:東京都港区、代表取締役:LEE KUNWOO)は、株式会社 SP&CO.(本社:東京都港区、代表取締役:湯澤 巧)がマネジメントを行う K-POP ガールズグループ「SECRET NUMBER(シークレットナンバ ー)」の日本公式ファンクラブサイトに「LITEVIEW」のシステム提供を行ったことをお知らせいたします。'
        },
        36: {
            category: NewsType.Media,
            title: '【BRIDGE】弊社サービスと新社外取締役の就任について掲載されました',
            date: 'August 3, 2022',
            thumbnail: './img/news/36/card.png',
            thumbnailSet: './img/news/36/card.png 1x, ./img/news/36/card@2x.png 2x, ./img/news/36/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/36',
            src: './md/cd_36_ja.md',
            text: '「BRIDGE」にて、弊社に関する記事を掲載していただきました。'
        },
        37: {
            category: NewsType.Media,
            title: '【Kstyle】【Yahoo!ニュース】「SECRET NUMBER」へのLITEVIEWのシステム提供について紹介されました',
            date: 'August 8, 2022',
            thumbnail: './img/news/37/card.png',
            thumbnailSet: './img/news/37/card.png 1x, ./img/news/37/card@2x.png 2x, ./img/news/37/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/37',
            src: './md/cd_37_ja.md',
            text: 'Kstyleにて、弊社についてご紹介いただき、Yahoo!ニュースにピックアップされました。'
        },
        38: {
            category: NewsType.PressRelease,
            title: '往年のタイガースファン必聴!元プロ野球選手初! 赤星憲広氏がプライベートラジオ番組を開始 配信システムはLITEVIEW',
            date: 'August 22, 2022',
            thumbnail: './img/news/38/card.png',
            thumbnailSet: './img/news/38/card.png 1x, ./img/news/38/card@2x.png 2x, ./img/news/38/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/38',
            src: './md/cd_38_ja.md',
            text: 'クリエイターのためのコンテンツプラットフォームサービス「LITEVIEW(ライトビュー)」 を開発・運営する LITEVIEW 株式会社(本社:東京都港区、代表取締役:LEE KUNWOO) は、元阪神タイガース選手で、現在は野球解説者・コメンテーターである赤星憲広氏に公式プライベートラジオ番組『赤星憲弘の入ってねぇーんだよ』の配信システムとして 「LITEVIEW」を採用いただきました。'
        },
        39: {
            category: NewsType.PressRelease,
            title: 'LITEVIEWご利用事例：元阪神タイガース外野手の赤星さんはLITEVIEWで結婚発表！？　ラジオ番組『赤星憲広の入ってねぇーんだよ！』',
            date: 'August 23, 2022',
            thumbnail: './img/news/39/card.png',
            thumbnailSet: './img/news/39/card.png 1x, ./img/news/39/card@2x.png 2x, ./img/news/39/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/39',
            src: './md/cd_39_ja.md',
            text: '元阪神タイガースの外野手の赤星憲広さんもラジオ番組でLITEVIEW（ライトビュー）を活用！　4月には結婚発表も行われました！'
        },
        40: {
            category: NewsType.PressRelease,
            title: '北斗晶さん・西山茉希さん出演 ライブ販売番組「ワケあって、数量販売 ポキート!」“波照間島の星降る島の黒糖アイス”など今回も即完売! LITEVIEW がシステム提供',
            date: 'August 25, 2022',
            thumbnail: './img/news/40/card.png',
            thumbnailSet: './img/news/40/card.png 1x, ./img/news/40/card@2x.png 2x, ./img/news/40/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/40',
            src: './md/cd_40_ja.md',
            text: 'クリエイターのためのコンテンツプラットフォームサービス「LITEVIEW(ライトビュー)」を開発・運営する LITEVIEW 株式会社(本社:東京都港区、代表取締役:LEE KUNWOO)は、北斗晶さん・西山茉希さん出演のライブ販売(ライブコマース)番組「ワケあって、数量販売 ポキート!」へ「LITEVIEW」が配信システム及びオリジナルアプリを提供いたしました。'
        },
        41: {
            category: NewsType.PressRelease,
            title: 'RIZINでの再起を図る！プロ格闘技イベント「GRACHAN」次回9月4日生中継！LITEVIEWがシステム提供',
            date: 'September 1, 2022',
            thumbnail: './img/news/41/card.png',
            thumbnailSet: './img/news/41/card.png 1x, ./img/news/41/card@2x.png 2x, ./img/news/41/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/41',
            src: './md/cd_41_ja.md',
            text: 'クリエイターのためのコンテンツプラットフォームサービス「LITEVIEW(ライトビュー)」を開発・運営する LITEVIEW 株式会社(本社:東京都港区、代表取締役: LEE KUNWOO)は、プロ総合格闘技団体「GRACHAN(グラチャン)」が運営する配信コミュニティ「GRACHAN放送局」の配信システムとして「LITEVIEW」を採用いただきました。'
        },
    },
    ko: {
        '-1': {
            category: NewsType.Job,
            title: 'LITEVIEW와 함께 세계를 바꿀 동료를 모집하고 있습니다.\n' +
                'Internship',
            date: 'January 3, 2026',
            thumbnail: './img/news/job/card-intern-v1.png',
            thumbnailSet: './img/news/job/card-intern-v1.png 1x, ./img/news/job/card-intern-v1@2x.png 2x, ./img/news/job/card-intern-v1@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './jobs'
        },
        0: {
            category: NewsType.Job,
            title: 'LITEVIEW와 함께 세계를 바꿀 동료를 모집하고 있습니다.\n' +
                'Engineer / PR Branding / \n' +
                'Marketing',
            date: 'January 3, 2026',
            thumbnail: './img/news/job/cardv2.png',
            thumbnailSet: './img/news/job/cardv2.png 1x, ./img/news/job/cardv2@2x.png 2x, ./img/news/job/cardv2@3x.png 3x',
            internalLink: './jobs'
        },
        2: {
            category: NewsType.PressRelease,
            title: 'LITEVIEW이 시드투자 라운드에서 5천만엔 투자를 유치하였습니다.',
            date: 'July 26, 2016',
            thumbnail: './img/news/1/card.png',
            thumbnailSet: './img/news/2/card.png 1x, ./img/news/2/card@2x.png 2x, ./img/news/2/card@3x.png 3x',
            externalLink: 'http://thebridge.jp/2016/08/pulit-secures-seed-round-funding',
            links: [{
                title: 'The Bridge에서 보기',
                url: 'http://thebridge.jp/en/2016/09/pulit-secures-seed-round-funding'
            }, {
                title: 'TechCrunch에서 보기',
                url: 'https://jp.techcrunch.com/2016/09/01/「電子透かしx超流通」でコンテンツ流通の新ル/'
            }]
        },
        3: {
            category: NewsType.PressRelease,
            title: 'LITEVIEW이 프리시리즈A 라운드에서 1억엔의 투자를 유치하였습니다.',
            date: 'June 21, 2017',
            thumbnail: './img/news/3/card.png',
            thumbnailSet: './img/news/3/card.png 1x, ./img/news/3/card@2x.png 2x, ./img/news/3/card@3x.png 3x',
            externalLink: 'http://thebridge.jp/en/2017/06/pulit-pre-series-a-round-funding',
            links: [{
                title: 'The Bridge에서 보기',
                url: 'http://thebridge.jp/en/2017/06/pulit-pre-series-a-round-funding'
            }, {
                title: 'TechCrunch에서 보기',
                url: 'https://jp.techcrunch.com/2017/06/21/pulit-second-fundrasing/'
            }, {
                title: 'CNET Japan에서 보기',
                url: 'https://japan.cnet.com/article/35103026/'
            }]
        },
        5: {
            category: NewsType.PressRelease,
            title: 'LITEVIEW이 성공적으로 시리즈A 투자를 유치하였습니다. (삼성, 라인 참여)',
            date: 'June 26, 2018',
            thumbnail: './img/news/5/card.png',
            thumbnailSet: './img/news/5/card.png 1x, ./img/news/5/card@2x.png 2x, ./img/news/5/card@3x.png 3x',
            externalLink: 'http://thebridge.jp/en/2018/06/pulit-series-a-round-funding',
            links: [{
                title: 'The Bridge에서 보기',
                url: 'http://thebridge.jp/en/2018/06/pulit-series-a-round-funding'
            }, {
                title: 'CNET Japan에서 보기',
                url: 'https://japan.cnet.com/article/35121386/'
            }]
        },
        14: {
            category: NewsType.PressRelease,
            title: 'LITEVIEW의 베타 서비스가 릴리스 되었습니다',
            date: 'February 28, 2019',
            thumbnail: './img/news/14/card.png',
            thumbnailSet: './img/news/14/card.png 1x, ./img/news/14/card@2x.png 2x, ./img/news/14/card@3x.png 3x',
            externalLink: 'https://gunosy.co.jp/news/159',
            links: [{
                title: 'Gunosy에서 보기',
                url: 'https://gunosy.co.jp/news/159'
            }, {
                title: 'Nikkei에서 보기',
                url: 'https://tech.nikkeibp.co.jp/atcl/nxt/news/18/04380/'
            }]
        },
        27: {
            category: NewsType.PressRelease,
            title: '전송 서비스를 누구나 쉽게 설계할 수 있는 "LITEVIEW" β서비스 시작',
            date: 'July 1, 2021',
            thumbnail: './img/news/27/card.png',
            thumbnailSet: './img/news/27/card.png 1x, ./img/news/27/card@2x.png 2x, ./img/news/27/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/27',
            src: './md/cd_24_kr.md',
            text: '도쿄를 거점으로 하는 LITEVIEW는, 동영상이나 디지털 화상의 컨텐츠 유통 기술의 개발로 얻은 지견과 기술력을 바탕으로, 크리에이터가 손쉽게 자체 서비스 할 수 있는 \'LITEVIEW\' β 버전 서비스를 시작했습니다.'
        },
        28: {
            category: NewsType.PressRelease,
            title: '콘텐츠 유통 기술의 LITEVIEW, KB Investment로 부터 시리즈B 자금 조달, 엔지니어와 비지니스 개발 인력 확보에 주력',
            date: 'January 1, 2022',
            thumbnail: './img/news/28/card.png',
            thumbnailSet: './img/news/28/card.png 1x, ./img/news/28/card@2x.png 2x, ./img/news/28/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/28',
            src: './md/cd_25_kr.md',
            text: '도쿄를 거점으로 하여 동영상이나 디지털화상의 콘텐츠 유통기술을 개발하는 LITEVIEW는 시리즈 B라운드에서 자금조달을 실시했다고 밝혔다.조달처는 KB Investment.'
        },
        29: {
            category: NewsType.PressRelease,
            title: 'Pulit 주식회사에서 LITEVIEW 주식회사로 회사명 변경 및 자금 조달 공지.',
            date: 'June 1, 2022',
            thumbnail: './img/news/29/card.png',
            thumbnailSet: './img/news/29/card.png 1x, ./img/news/29/card@2x.png 2x, ./img/news/29/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/29',
            src: './md/cd_26_kr.md',
            text: 'Pulit 주식회사는 2022년 5월 13일, LITEVIEW 주식회사(라이트뷰 주식회사)로 회사명을 변경했습니다.'
        },
        30: {
            category: NewsType.PressRelease,
            title: 'LITEVIEW 주식회사의 미션 ["풀타임 크리에이터" 늘리기]란?',
            date: 'June 3, 2022',
            thumbnail: './img/news/30/card.png',
            thumbnailSet: './img/news/30/card.png 1x, ./img/news/30/card@2x.png 2x, ./img/news/30/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/30',
            src: './md/cd_27_kr.md',
            text: '저희 LITEVIEW(라이트뷰)가 내세우는 미션은 \'풀타임 크리에이터\'를 늘리는 것.'
        },
        31: {
            category: NewsType.PressRelease,
            title: 'LITEVIEW 이용 사례 : 호쿠토 아키 씨 · 니시야마 마키 씨의 라이브 커머스 "이끼 있어, 수량 한정 포키트!"',
            date: 'June 8, 2022',
            thumbnail: './img/news/31/card.png',
            thumbnailSet: './img/news/31/card.png 1x, ./img/news/31/card@2x.png 2x, ./img/news/31/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/31',
            src: './md/cd_28_kr.md',
            text: 'LITEVIEW(라이트 뷰)는 다양한 분들이 이용하고 있습니다만, 탤런트 호쿠토 아키 씨·니시야마 마키 씨의 라이브 커머스(라이브 전달에 의한 온라인 판매) 프로그램에도 활용되고 있습니다!'
        },
        34: {
            category: NewsType.PressRelease,
            title: '새 이사에 Toshimasa Baba씨, Goshi Yamaguchi씨 취임 소식',
            date: 'August 3, 2022',
            thumbnail: './img/news/34/card.png',
            thumbnailSet: './img/news/34/card.png 1x, ./img/news/34/card@2x.png 2x, ./img/news/34/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/34',
            src: './md/cd_34_kr.md',
            text: 'LITEVIEW 주식회사(본사:도쿄도 미나토구, CEO:LEE KUNWOO)는, 경영 체제의 강화를 위해, Toshimasa Baba씨, Goshi Yamaguchi씨의 두 명이 이사로 취임했음을 알려드립니다.이번 임원 체제 강화로 LITEVIEW 주식회사는 \'LITEVIEW(라이트뷰)\'를 통해 더욱 창작자에게 버팀목이 되는 서비스를 제공할 수 있도록 노력하겠습니다.'
        },
        35: {
            category: NewsType.PressRelease,
            title: 'K팝 걸그룹 시크릿넘버 공식 팬클럽 사이트 오늘 오픈! LITEVIEW가 시스템 제공',
            date: 'August 8, 2022',
            thumbnail: './img/news/35/card.png',
            thumbnailSet: './img/news/35/card.png 1x, ./img/news/35/card@2x.png 2x, ./img/news/35/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/35',
            src: './md/cd_35_kr.md',
            text: '크리에이터를 위한 콘텐츠 플랫폼 서비스 \'라이티비(라이트뷰)\'를 개발·운영하는 주식회사 라이티비(본사: 도쿄 미나토구, 대표이사: LE KUNWOO)는 주식회사 에스피앤코(본사: 도쿄 미나토구, 대표이사: 유자와 타쿠미)가 매니지먼트를 하는 K팝 걸그룹 \'시크릿넘버(시크릿넘버)\'의 일본 공식 팬클럽 사이트에 \'라이티비(LITEVIEW)\'의 시스템을 제공했음을 알려드립니다.'
        },
        36: {
            category: NewsType.Media,
            title: '[BRIDGE] 당사 서비스와 신 사외이사 취임에 대해 게재되었습니다.',
            date: 'August 3, 2022',
            thumbnail: './img/news/36/card.png',
            thumbnailSet: './img/news/36/card.png 1x, ./img/news/36/card@2x.png 2x, ./img/news/36/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/36',
            src: './md/cd_36_kr.md',
            text: '「BRIDGE」에서, 당사에 관한 기사를 게재했습니다.'
        },
        37: {
            category: NewsType.Media,
            title: '【Kstyle】 【Yahoo! 뉴스】「SECRET NUMBER」에 LITEVIEW의 시스템 제공에 대해 소개되었습니다',
            date: 'August 8, 2022',
            thumbnail: './img/news/37/card.png',
            thumbnailSet: './img/news/37/card.png 1x, ./img/news/37/card@2x.png 2x, ./img/news/37/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/37',
            src: './md/cd_37_kr.md',
            text: 'Kstyle에서 저희 회사에 대해 소개받고 야후뉴스에 픽업되었습니다.'
        },
        38: {
            category: NewsType.PressRelease,
            title: '왕년의 타이거즈 팬 필청! 전 프로야구 선수 최초! 아카호시 노리히로씨가 프라이빗 라디오 프로그램을 개시 전달 시스템은 LITEVIEW',
            date: 'August 22, 2022',
            thumbnail: './img/news/38/card.png',
            thumbnailSet: './img/news/38/card.png 1x, ./img/news/38/card@2x.png 2x, ./img/news/38/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/38',
            src: './md/cd_38_kr.md',
            text: '크리에이터를 위한 콘텐츠 플랫폼 서비스 「LITEVIEW(라이트뷰)」를 개발·운영하는 LITEVIEW 주식회사(본사: 도쿄도 미나토구, 대표이사: LE KUNWOO)는 전 한신 타이거스 선수로, 현재는 야구 해설가·코멘테이터 아카호시 노리히로씨에게 공식 프라이빗 라디오 프로그램 「아카호시 노리히로가 들어오지 않았어」의 전달 시스템으로서 「LITEVIEW」를 채용해 주셨습니다.'
        },
        39: {
            category: NewsType.PressRelease,
            title: 'LITEVIEW 이용 사례 : 전 한신 타이거스 외야수 아카호시씨는 LITEVIEW에서 결혼 발표!? 라디오 프로그램 『아카호시 노리히로의 들어가지 않았어!』',
            date: 'August 23, 2022',
            thumbnail: './img/news/39/card.png',
            thumbnailSet: './img/news/39/card.png 1x, ./img/news/39/card@2x.png 2x, ./img/news/39/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/39',
            src: './md/cd_39_kr.md',
            text: '전 한신 타이거즈의 외야수 아카호시 노리히로씨도 라디오 프로그램에서 LITEVIEW(라이트뷰)를 활용! 4월에는 결혼 발표도 행해졌습니다!'
        },
        40: {
            category: NewsType.PressRelease,
            title: '호쿠토아키씨·니시야마 마키씨 출연 라이브 판매 프로그램 「하자, 수량 판매 포크!」"하테루마섬의 별 내리는 섬의 흑당 아이스" 등 이번에도 즉시 매진! LITEVIEW가 시스템 제공',
            date: 'August 25, 2022',
            thumbnail: './img/news/40/card.png',
            thumbnailSet: './img/news/40/card.png 1x, ./img/news/40/card@2x.png 2x, ./img/news/40/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/40',
            src: './md/cd_40_kr.md',
            text: '크리에이터를 위한 콘텐츠 플랫폼 서비스 \'라이티비(LITEVIEW)\'를 개발·운영하는 라이티비 주식회사(본사: 도쿄 미나토구, 대표이사: LEKUNWOO)는 호쿠두정·니시야마 마키씨 출연 라이브 판매(라이브 커머스) 프로그램 \'와케있어, 수량 판매 포트!\'에 \'라이티비\'가 전달 시스템 및 오리지널 앱을 제공했습니다.'
        },
        41: {
            category: NewsType.PressRelease,
            title: 'RIZIN으로 재기를 도모한다!프로격투기 이벤트 \'GRACHAN\' 다음 9월 4일 생중계! LITEVIEW가 시스템 제공',
            date: 'September 1, 2022',
            thumbnail: './img/news/41/card.png',
            thumbnailSet: './img/news/41/card.png 1x, ./img/news/41/card@2x.png 2x, ./img/news/41/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/41',
            src: './md/cd_41_kr.md',
            text: '창작자를 위한 콘텐츠 플랫폼 서비스 \'라이티비(LITEVIEW)\'를 개발·운영하는 라이티비 주식회사(본사: 도쿄 미나토구, 대표이사: LEKUNWOO)는 프로 종합격투기 단체 \'그락찬(그라찬)\'이 운영하는 방송 커뮤니티 \'그락한 방송국\'의 전달 시스템으로 \'라이티비(LITEVIEW)\'를 채택했습니다.'
        },
    },
    en: {
        '-1': {
            category: NewsType.Job,
            title: 'We are looking for people to change the world with LITEVIEW.\n' +
                'Internship',
            date: 'January 3, 2026',
            thumbnail: './img/news/job/card-intern-v1.png',
            thumbnailSet: './img/news/job/card-intern-v1.png 1x, ./img/news/job/card-intern-v1@2x.png 2x, ./img/news/job/card-intern-v1@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './jobs'
        },
        0: {
            category: NewsType.Job,
            title: 'We are looking for people to change the world with LITEVIEW.\n' +
                'Engineer / PR Branding / \n' +
                'Marketing',
            date: 'January 3, 2026',
            thumbnail: './img/news/job/cardv2.png',
            thumbnailSet: './img/news/job/cardv2.png 1x, ./img/news/job/cardv2@2x.png 2x, ./img/news/job/cardv2@3x.png 3x',
            internalLink: './jobs'
        },
        2: {
            category: NewsType.PressRelease,
            title: 'LITEVIEW secured $500K in its seed round.',
            date: 'July 26, 2016',
            thumbnail: './img/news/1/card.png',
            thumbnailSet: './img/news/2/card.png 1x, ./img/news/2/card@2x.png 2x, ./img/news/2/card@3x.png 3x',
            externalLink: 'http://thebridge.jp/en/2016/09/pulit-secures-seed-round-funding',
            links: [{
                title: 'Open The Bridge',
                url: 'http://thebridge.jp/en/2016/09/pulit-secures-seed-round-funding'
            }, {
                title: 'Open TechCrunch',
                url: 'https://jp.techcrunch.com/2016/09/01/「電子透かしx超流通」でコンテンツ流通の新ル/'
            }]
        },
        3: {
            category: NewsType.PressRelease,
            title: 'LITEVIEW secured $1M in its pre-series A round.',
            date: 'June 21, 2017',
            thumbnail: './img/news/3/card.png',
            thumbnailSet: './img/news/3/card.png 1x, ./img/news/3/card@2x.png 2x, ./img/news/3/card@3x.png 3x',
            externalLink: 'http://thebridge.jp/en/2017/06/pulit-pre-series-a-round-funding',
            links: [{
                title: 'Open The Bridge',
                url: 'http://thebridge.jp/en/2017/06/pulit-pre-series-a-round-funding'
            }, {
                title: 'Open TechCrunch',
                url: 'https://jp.techcrunch.com/2017/06/21/pulit-second-fundrasing/'
            }, {
                title: 'Open CNET Japan',
                url: 'https://japan.cnet.com/article/35103026/'
            }]
        },
        5: {
            category: NewsType.PressRelease,
            title: 'LITEVIEW got the series A round funding with Samsung and LINE.',
            date: 'June 26, 2018',
            thumbnail: './img/news/5/card.png',
            thumbnailSet: './img/news/5/card.png 1x, ./img/news/5/card@2x.png 2x, ./img/news/5/card@3x.png 3x',
            externalLink: 'http://thebridge.jp/en/2018/06/pulit-series-a-round-funding',
            links: [{
                title: 'Open The Bridge',
                url: 'http://thebridge.jp/en/2018/06/pulit-series-a-round-funding'
            }, {
                title: 'Open CNET Japan',
                url: 'https://japan.cnet.com/article/35121386/'
            }]
        },
        14: {
            category: NewsType.PressRelease,
            title: 'The β-service of LITEVIEW is released.',
            date: 'February 28, 2019',
            thumbnail: './img/news/14/card.png',
            thumbnailSet: './img/news/14/card.png 1x, ./img/news/14/card@2x.png 2x, ./img/news/14/card@3x.png 3x',
            externalLink: 'https://gunosy.co.jp/news/159',
            links: [{
                title: 'Open Gunosy',
                url: 'https://gunosy.co.jp/news/159'
            }, {
                title: 'Open Nikkei',
                url: 'https://tech.nikkeibp.co.jp/atcl/nxt/news/18/04380/'
            }]
        },
        27: {
            category: NewsType.PressRelease,
            title: '"LITEVIEW" Beta Service Begins, Enabling Anyone to Easily Design Distribution Services',
            date: 'July 1, 2021',
            thumbnail: './img/news/27/card.png',
            thumbnailSet: './img/news/27/card.png 1x, ./img/news/27/card@2x.png 2x, ./img/news/27/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/27',
            src: './md/cd_24_en.md',
            text: 'Tokyo-based LITEVIEW has launched the beta version of "LITEVIEW," a service that allows creators to easily design their own distribution services based on the knowledge and technical capabilities they have acquired through the development of video and digital image content distribution technology.'
        },
        28: {
            category: NewsType.PressRelease,
            title: 'Content Distribution Technology Company LITEVIEW Raises Series B Funding from KB Investment -- Focuses on Securing Engineers and Business Development Talent',
            date: 'January 1, 2022',
            thumbnail: './img/news/28/card.png',
            thumbnailSet: './img/news/28/card.png 1x, ./img/news/28/card@2x.png 2x, ./img/news/28/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/28',
            src: './md/cd_25_en.md',
            text: 'LITEVIEW, a Tokyo-based developer of content distribution technology for video and digital images, announced that it has raised a Series B round of funding. The funding was provided by KB Investment.'
        },
        29: {
            category: NewsType.PressRelease,
            title: 'Notice of Corporation name change and Fund Raising, Pulit Inc. to LITEVIEW Inc.',
            date: 'June 1, 2022',
            thumbnail: './img/news/29/card.png',
            thumbnailSet: './img/news/29/card.png 1x, ./img/news/29/card@2x.png 2x, ./img/news/29/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/29',
            src: './md/cd_26_en.md',
            text: 'We are pleased to announce that Pulit Inc. has changed its company name to LITEVIEW Inc. on May 13, 2022.'
        },
        30: {
            category: NewsType.PressRelease,
            title: 'What is LITEVIEW\'s mission "to increase the number of FULL-TIME CREATORS"?',
            date: 'June 3, 2022',
            thumbnail: './img/news/29/card.png',
            thumbnailSet: './img/news/29/card.png 1x, ./img/news/29/card@2x.png 2x, ./img/news/29/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/29',
            src: './md/cd_27_en.md',
            text: 'Our mission at LITEVIEW is to "increase the number of full-time creators".'
        },
        31: {
            category: NewsType.PressRelease,
            title: 'LITEVIEW Case Study: Live Commerce by Akira Hokuto and Maki Nishiyama, "Poquito with Limited Quantity!',
            date: 'June 8, 2022',
            thumbnail: './img/news/31/card.png',
            thumbnailSet: './img/news/31/card.png 1x, ./img/news/31/card@2x.png 2x, ./img/news/31/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/31',
            src: './md/cd_28_en.md',
            text: 'LITEVIEW has been used by a variety of people, including celebrities Akira Hokuto and Maki Nishiyama for their live commerce (online sales via live streaming) programs!'
        },
        34: {
            category: NewsType.PressRelease,
            title: 'Toshimasa Baba and Goshi Yamaguchi are appointed as new outside directors.',
            date: 'August 3, 2022',
            thumbnail: './img/news/34/card.png',
            thumbnailSet: './img/news/34/card.png 1x, ./img/news/34/card@2x.png 2x, ./img/news/34/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/34',
            src: './md/cd_34_en.md',
            text: 'LITEVIEW Inc. (Head office: Minato-ku, Tokyo; CEO: LEE KUNWOO) announces that Toshimasa Baba and Goshi Yamaguchi have been appointed as outside directors to strengthen its management structure. With this strengthening of the executive structure, LITEVIEW, Inc. will work to provide even more supportive services to creators through "LITEVIEW".'
        },
        35: {
            category: NewsType.PressRelease,
            title: 'K-POP Girls Group "SECRET NUMBER" Official Fan Club Site Opens Today! System provided by LITEVIEW',
            date: 'August 8, 2022',
            thumbnail: './img/news/35/card.png',
            thumbnailSet: './img/news/35/card.png 1x, ./img/news/35/card@2x.png 2x, ./img/news/35/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/35',
            src: './md/cd_35_en.md',
            text: '(Head office: Minato-ku, Tokyo; Representative Director: LEE KUNWOO), which develops and operates the "LITEVIEW" content platform service for creators, has provided the "LITEVIEW" system to the official Japanese fan club site of the K-POP girl group "SECRET NUMBER" managed by SP&CO. (Head Office: Minato-ku, Tokyo; Representative Director: Takumi Yuzawa), a K-POP girl group managed by SP&CO.'
        },
        36: {
            category: NewsType.Media,
            title: '[BRIDGE] Our services and the appointment of a new outside director were featured in an article.',
            date: 'August 3, 2022',
            thumbnail: './img/news/36/card.png',
            thumbnailSet: './img/news/36/card.png 1x, ./img/news/36/card@2x.png 2x, ./img/news/36/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/36',
            src: './md/cd_36_en.md',
            text: 'An article about our company was published in "BRIDGE".'
        },
        37: {
            category: NewsType.Media,
            title: '[Kstyle] [Yahoo! News] LITEVIEW\'s system provision to "SECRET NUMBER" was introduced.',
            date: 'August 8, 2022',
            thumbnail: './img/news/37/card.png',
            thumbnailSet: './img/news/37/card.png 1x, ./img/news/37/card@2x.png 2x, ./img/news/37/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/37',
            src: './md/cd_37_en.md',
            text: 'Our company was introduced in Kstyle and picked up by Yahoo!'
        },
        38: {
            category: NewsType.PressRelease,
            title: 'A must-listen for Tigers fans of yesteryear! The first by a former professional baseball player! Norihiro Akahoshi has started a private radio show. Distribution system is LITEVIEW.',
            date: 'August 22, 2022',
            thumbnail: './img/news/38/card.png',
            thumbnailSet: './img/news/38/card.png 1x, ./img/news/38/card@2x.png 2x, ./img/news/38/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/38',
            src: './md/cd_38_en.md',
            text: '(Head office: Minato-ku, Tokyo; Representative Director: LEE KUNWOO), which develops and operates the "LITEVIEW" content platform service for creators, is pleased to announce that Norihiro Akaboshi, former Hanshin Tigers player and now a baseball commentator and commentator, has adopted LITEVIEW as the delivery system for his official private radio program "Norihiro Akaboshi\'s Not in! LITEVIEW" has been adopted by Norihiro Akahoshi, a former Hanshin Tigers player who is now a baseball commentator and commentator, as his official private radio program.'
        },
        39: {
            category: NewsType.PressRelease,
            title: 'LITEVIEW Case Study: Former Hanshin Tigers outfielder Akahoshi announces his marriage on LITEVIEW!　Radio program "Norihiro Akahoshi\'s not in!',
            date: 'August 23, 2022',
            thumbnail: './img/news/39/card.png',
            thumbnailSet: './img/news/39/card.png 1x, ./img/news/39/card@2x.png 2x, ./img/news/39/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/39',
            src: './md/cd_39_en.md',
            text: 'Former Hanshin Tigers outfielder Norihiro Akahoshi also utilized LITEVIEW on his radio show!　And in April, he even announced his marriage!'
        },
        40: {
            category: NewsType.PressRelease,
            title: 'Akira Hokuto and Maki Nishiyama appeared in the live sales program "Pokito! Brown sugar ice cream from the starry island of Hateruma" and other items sold out immediately! System provided by LITEVIEW',
            date: 'August 25, 2022',
            thumbnail: './img/news/40/card.png',
            thumbnailSet: './img/news/40/card.png 1x, ./img/news/40/card@2x.png 2x, ./img/news/40/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/40',
            src: './md/cd_40_en.md',
            text: '(HQ: Minato-ku, Tokyo; CEO: LEE KUNWOO), which develops and operates the "LITEVIEW" content platform service for creators, is to host a live sales (live commerce) program starring Akira Hokuto and Maki Nishiyama, "Why Are You Selling Pokeat? LITEVIEW" will be distributed to the live sales (live commerce) program "Why are you selling so much? LITEVIEW" has provided its delivery system and original application to the live sales (live commerce) program "Why There\'s a Quantity Selling Poquito!'
        },
        41: {
            category: NewsType.PressRelease,
            title: 'RIZIN to make a comeback! Professional Martial Arts Event "GRACHAN" Next Live Broadcast on September 4!',
            date: 'September 1, 2022',
            thumbnail: './img/news/41/card.png',
            thumbnailSet: './img/news/41/card.png 1x, ./img/news/41/card@2x.png 2x, ./img/news/41/card@3x.png 3x',
            externalLink: 'about:blank',
            internalLink: './news/41',
            src: './md/cd_41_en.md',
            text: '(Head Office: Minato-ku, Tokyo; Representative Director: LEE KUNWOO), which develops and operates the "LITEVIEW" content platform service for creators, has been selected by the professional mixed martial arts organization "GRACHAN LITEVIEW" has been adopted as the delivery system for the "GRACHAN Broadcasting Station" community operated by the professional mixed martial arts organization "GRACHAN".'
        },
    },
});

export let lJobs = new LocalizedStrings({
        ja: {
            'job_1_position': 'iOS Engineer',
            'job_1_md_src': './md/job/job-ios-ja.md',

            'job_2_position': 'Android Engineer',
            'job_2_md_src': './md/job/job-and-ja.md',

            'job_3_position': 'Server/Web Engineer',
            'job_3_md_src': './md/job/job-web-ja.md',

            'job_4_position': 'Web Director',
            'job_4_md_src': './md/job/job-webdirector-ja.md',

            'job_5_position': 'PRブランディング',
            'job_5_md_src': './md/job/job-pr-ja.md',

            'job_6_position': 'デジタルマーケティング',
            'job_6_md_src': './md/job/job-digital-marketing-ja.md',

            'job_7_position': 'インターン',
            'job_7_md_src': './md/job/job-intern-ja.md',
        },
        ko: {
            'job_1_position': 'iOS Engineer',
            'job_1_md_src': './md/job/job-ios-kr.md',

            'job_2_position': 'Android Engineer',
            'job_2_md_src': './md/job/job-and-kr.md',

            'job_3_position': 'Server/Web Engineer',
            'job_3_md_src': './md/job/job-web-kr.md',

            'job_4_position': 'Web Director',
            'job_4_md_src': './md/job/job-webdirector-kr.md',

            'job_5_position': 'PR Branding',
            'job_5_md_src': './md/job/job-pr-kr.md',

            'job_6_position': 'Digital Marketing',
            'job_6_md_src': './md/job/job-digital-marketing-kr.md',

            'job_7_position': 'Internship',
            'job_7_md_src': './md/job/job-intern-kr.md',
        },
        en: {
            'job_1_position': 'iOS Engineer',
            'job_1_md_src': './md/job/job-ios-en.md',

            'job_2_position': 'Android Engineer',
            'job_2_md_src': './md/job/job-and-en.md',

            'job_3_position': 'Server/Web Engineer',
            'job_3_md_src': './md/job/job-web-en.md',

            'job_4_position': 'Web Director',
            'job_4_md_src': './md/job/job-webdirector-en.md',

            'job_5_position': 'PR Branding',
            'job_5_md_src': './md/job/job-pr-en.md',

            'job_6_position': 'Digital Marketing',
            'job_6_md_src': './md/job/job-digital-marketing-en.md',

            'job_7_position': 'Internship',
            'job_7_md_src': './md/job/job-intern-en.md',
        }
    })
;



// WEBPACK FOOTER //
// ./src/Constants/Strings.js